/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Financial dashboard module status */
export enum FinancialModuleStatusEnum {
  READY = "READY",
  EMPTY = "EMPTY",
  LIMITED = "LIMITED",
  ERROR = "ERROR",
}

/** relation status enum */
export enum RelationStatusEnum {
  ENABLE = "ENABLE",
  DISABLE = "DISABLE",
}

/** relation ranking enum */
export enum RelationRankingEnum {
  ROLE = "ROLE",
  CREATED = "CREATED",
  LATEST_POST_TIME = "LATEST_POST_TIME",
}

/** member product level */
export enum MemberProductLevelEnum {
  EXPERT = "EXPERT",
  PRO = "PRO",
  FREE = "FREE",
}

/** pay status */
export enum PaymentPlanStatus {
  APPROVAL_PENDING = "APPROVAL_PENDING",
  APPROVED = "APPROVED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
}

/** token usage */
export enum PayBusinessType {
  EDGEN_SUB = "EDGEN_SUB",
  REFUND = "REFUND",
}

/** Subscription management capability */
export enum SubscriptionCapability {
  CANCEL_AT_PERIOD_END = "CANCEL_AT_PERIOD_END",
  RESUME = "RESUME",
  UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD",
  CHANGE_PLAN = "CHANGE_PLAN",
  REFUND = "REFUND",
  HOSTED_PORTAL = "HOSTED_PORTAL",
}

/** CIK position change type enumeration */
export enum CikChangeTypeEnum {
  NEW_POSITION = "NEW_POSITION",
  CLOSED_POSITION = "CLOSED_POSITION",
  INCREASED = "INCREASED",
  DECREASED = "DECREASED",
  UNCHANGED = "UNCHANGED",
}

/** Checkout UI mode; HOSTED redirects to the provider page, EMBEDDED returns client_secret */
export enum CheckoutUiMode {
  HOSTED = "HOSTED",
  EMBEDDED = "EMBEDDED",
}

/** Opportunity status */
export enum OpportunityStatusEnum {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
}

/** Opportunity business type */
export enum OpportunityTypeEnum {
  AI_PICK = "AI_PICK",
  EARNINGS = "EARNINGS",
  IPO = "IPO",
}

/** Asset account platform type enumeration */
export enum PositionAccountStatusEnum {
  ACTIVE = "ACTIVE",
  AUTHORIZATION_EXPIRED = "AUTHORIZATION_EXPIRED",
  MEMBER_EXPIRED = "MEMBER_EXPIRED",
  CREDIT_INSUFFICIENT = "CREDIT_INSUFFICIENT",
}

/** Synchronization status enumeration */
export enum SyncStatusEnum {
  PENDING = "PENDING",
  SYNCING = "SYNCING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

/** Authorization status enumeration */
export enum AuthorizationStatusEnum {
  PENDING = "PENDING",
  AUTHORIZED = "AUTHORIZED",
  EXPIRED = "EXPIRED",
  REVOKED = "REVOKED",
}

/** Account type enumeration */
export enum PositionAccountTypeEnum {
  SPOT = "SPOT",
  SWAP = "SWAP",
  FUTURES = "FUTURES",
}

/** Asset type enumeration */
export enum PositionAssetTypeEnum {
  TOKEN = "TOKEN",
  STOCK = "STOCK",
}

/** Asset account platform type enumeration */
export enum PositionAccountPlatformEnum {
  EDGEN = "EDGEN",
  SNAPTRADE = "SNAPTRADE",
  OKX = "OKX",
  BINANCE = "BINANCE",
  HYPERLIQUID = "HYPERLIQUID",
}

/** agent status */
export enum AgentStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  COMING_SOON = "COMING_SOON",
}

/** agent report level */
export enum AgentReportLevelEnum {
  HIGH = "HIGH",
  MID = "MID",
  LOW = "LOW",
}

/** agent report category */
export enum AgentReportCategoryEnum {
  STOCK = "STOCK",
  CRYPTO = "CRYPTO",
}

/** Equity grant code enum */
export enum EquityGrantCodeEnum {
  MEMBER_CANCEL_SUBSCRIPTION_RETENTION_CREDIT = "MEMBER_CANCEL_SUBSCRIPTION_RETENTION_CREDIT",
}

/** Payment channel */
export enum PayChannel {
  PAYPAL = "PAYPAL",
  WALLET = "WALLET",
  STRIPE = "STRIPE",
  APPLE_IAP = "APPLE_IAP",
  GOOGLE_IAP = "GOOGLE_IAP",
  AIRWALLEX = "AIRWALLEX",
}

/** token usage */
export enum PayType {
  CONTINUOUS = "CONTINUOUS",
  NON_CONTINUOUS = "NON_CONTINUOUS",
}

/** membership status */
export enum MemberStatusEnum {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
}

/** reaction kind */
export enum ReactionSubKindEnum {
  UPVOTE = "UPVOTE",
  DOWNVOTE = "DOWNVOTE",
  UPHIGHLIGHT = "UPHIGHLIGHT",
  DOWNHIGHLIGHT = "DOWNHIGHLIGHT",
}

/** reaction kind */
export enum ReactionKindEnum {
  LIKE = "LIKE",
  VOTE = "VOTE",
  MEGAPHONE = "MEGAPHONE",
  TRIBE_BLOCK = "TRIBE_BLOCK",
  TRIBE_PIN = "TRIBE_PIN",
  USER_BLOCK = "USER_BLOCK",
  USER_PIN = "USER_PIN",
  HIGHLIGHT = "HIGHLIGHT",
  TIPPING = "TIPPING",
  VERIFY_QUEST = "VERIFY_QUEST",
  SCORE = "SCORE",
}

/** transaction status */
export enum OwnerStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface BaseResponse {
  /** sub code */
  code?: number;
  /** information for the response */
  msg?: string;
  data?: object;
  errors?: Error[];
}

export interface Error {
  /** error type, eg. Generic, InvalidRequest, ClientForbidden */
  reason?: string;
  /** human-friendly message */
  detail?: string;
  /** chart */
  location?: string;
  /** parameter */
  locationType?: string;
}

/** Owner info */
export interface Owner {
  /** id */
  id?: string;
  /** osp_address */
  osp_address?: string;
  /** eoa_address */
  eoa_address?: string;
  /** issue_channel */
  issue_channel?: string;
  /** issue_platform */
  issue_platform?: string;
  /** handle */
  issue_name?: string;
  /** issue email */
  issue_email?: string;
  /** language */
  language?: string;
  /**
   * Ed 称呼用户的昵称；ksocial social_owner_v4.nick_name。未设置则省略。
   * @maxLength 64
   */
  nick_name?: string;
  /** issue avatar */
  avatar?: string;
  /** transaction status */
  status?: OwnerStatusEnum;
  /** app_id */
  app_id?: string;
  /**
   * deposit code
   * @deprecated
   */
  deposit_code?: string;
  /** deposit code */
  unique_code?: string;
  /**
   * Invited Count
   * @format int64
   */
  invited_count?: number;
  profile?: Profile[];
}

/** profile info */
export interface Profile {
  /** user gid */
  gid?: string;
  chain_id?: string;
  /** profile id */
  profile_id?: string;
  handle?: string;
  bio?: string;
  background?: string;
  /** picture(url,height/width/mimeType...) or NftImage(contractAddress,tokenId,uri) */
  avatar?: string;
  /** todo support? */
  metadata?: object;
  /**
   * owner id
   * @deprecated
   */
  owner?: string;
  /** owner address */
  address?: string;
}

export interface AddReactionRequest {
  referenced_profile_id?: string;
  referenced_content_id?: string;
  /**
   * display content id
   * @format string
   */
  referenced_view_id?: string;
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction kind */
  sub_kind?: ReactionSubKindEnum;
  score?: number;
}

export interface Reaction {
  /** id */
  id?: string;
  /** user id */
  profile_id?: string;
  /** user_gid */
  user_gid?: string;
  /** dispay content id */
  view_id?: string;
  /** chain content id */
  content_id?: string;
  /** @format int64 */
  created?: number;
  /**
   * like count
   * @format int64
   */
  like_count?: number;
  /**
   * 同意数
   * @format int64
   */
  upvote_count?: number;
  /**
   * 反对数
   * @format int64
   */
  downvote_count?: number;
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction kind */
  sub_kind?: ReactionSubKindEnum;
  /** profile info */
  profile?: Profile;
}

export type ReactionResponse = BaseResponse & {
  data?: Reaction;
};

export interface Member {
  /**
   * owner id
   * @example 123234234233423
   */
  id?: string;
  /** membership status */
  status?: MemberStatusEnum;
  /**
   * is auto renewal
   * @example true
   */
  auto_renewal?: boolean;
  /**
   * first time
   * @format int64
   * @example 1751435277220
   */
  first_time?: number;
  /**
   * effect time
   * @format int64
   * @example 1751435277220
   */
  effect_time?: number;
  /**
   * expire time
   * @format int64
   * @example 1752249600000
   */
  expire_time?: number;
  /**
   * remain minutes
   * @format int64
   * @example 30
   */
  remain_minutes?: number;
  product?: MemberProduct;
  order?: MemberOrder;
  renewal_product?: MemberProduct;
  /** Member credit balance summary */
  credit?: MemberCredit;
  /** List of available products with action status and product type */
  available_products?: {
    /**
     * Product ID
     * @example "expert_year_20260127"
     */
    product_id?: string;
    /**
     * Action type, UPGRADE / RENEW / UPGRADE_TO_LATEST / PURCHASE
     * @example "UPGRADE"
     */
    action?: "UPGRADE" | "RENEW" | "UPGRADE_TO_LATEST" | "PURCHASE";
    /**
     * Product type, normal / trial (used to distinguish trial products)
     * @example "normal"
     */
    product_type?: "normal" | "trial";
  }[];
}

export type MemberResponse = BaseResponse & {
  data?: Member;
};

/** Member credit balance summary */
export interface MemberCredit {
  /**
   * Total credit amount
   * @format int64
   */
  total?: number;
  /**
   * Used credit amount
   * @format int64
   */
  used?: number;
  /**
   * Available credit amount
   * @format int64
   */
  available?: number;
  /**
   * Total credit from last period (carry-over amount)
   * @format int64
   */
  rollover?: number;
  /**
   * Total credit from permanent amount
   * @format int64
   */
  permanent?: number;
  /**
   * Current cycle policyId
   * @example "pro_month_260101_01"
   */
  policy_id?: string;
  /**
   * Credit cycle start time (milliseconds timestamp, calculated from segments resetTime)
   * @format int64
   * @example 1704067200000
   */
  start_time?: number;
  /**
   * Credit cycle end time (milliseconds timestamp, calculated from resetTime + 1 natural month/year)
   * @format int64
   * @example 1706745600000
   */
  end_time?: number;
}

export interface MemberEquity {
  /**
   * equity id
   * @example "demo_1"
   */
  id?: string;
  /**
   * equity name
   * @example "demo_1"
   */
  name?: string;
  /**
   * equity limit
   * @example 100
   */
  params?: string;
  /**
   * equity category
   * @example "Trading Strategy"
   */
  category?: string;
  /**
   * equity status
   * @example "OWN"
   */
  status?: "OWN" | "NOT_OWN";
  /**
   * equity weight
   * @format int64
   * @example 1
   */
  weight?: number;
  /** equity remark */
  remark?: string;
  type?: string;
  internal_category?: string;
  /** member equity status */
  equity_status?: "ACTIVE" | "INACTIVE";
}

export interface MemberProductCurrency {
  /**
   * the type of the currency
   * @example "crypto"
   */
  type?: string;
  /**
   * the channel of the currency
   * @example "paypal/wallet"
   */
  channel?: string;
  /**
   * currency
   * @example "USDC"
   */
  currency?: string;
  /**
   * address
   * @example "contract address"
   */
  address?: string;
  /**
   * the price of the currency。后端实际下发的是**字符串**（线上实测 "299.99" / "1.99"）， 此前声明为 number 与线上不符：TS 侧靠满地的 Number(...) 兜住、KMP 侧靠 Json { isLenient = true } 兜住，任一处漏掉即静默出错。按真相声明为 string， 消费方一律显式转数值后再做算术。
   * @example "0.99"
   */
  price?: string;
  /**
   * the chain id of the currency
   * @example 8453
   */
  chain_id?: string;
  /**
   * the ecosystem of the currency
   * @example "bnb/base"
   */
  ecosystem?: string;
  /**
   * the icon of the currency
   * @example "ipfs://xx"
   */
  icon?: string;
  /**
   * the display description of the currency
   * @example "USDT via ERC-20"
   */
  description?: string;
  /**
   * the display decimals of the currency
   * @format int32
   */
  decimals?: number;
}

export interface MemberOrder {
  /**
   * order id
   * @example 123234234233423
   */
  id?: string;
  /**
   * effect time
   * @format int64
   * @example 1751435277220
   */
  effect_time?: number;
  /**
   * expire time
   * @format int64
   * @example 1752249600000
   */
  expire_time?: number;
  /** condition type */
  condition_type?: "REWARD" | "TOKEN";
  /**
   * pay channel
   * @example "PAYPAL"
   */
  pay_channel?: string;
}

export type MemberProductEffectivePeriod = {
  unit?: "day" | "week" | "month" | "year" | "lifetime" | null;
  /** @format int32 */
  count?: number | null;
} | null;

export interface MemberProduct {
  /**
   * product id
   * @example "pro_month"
   */
  id?: string;
  /**
   * product name
   * @example "pro"
   */
  name?: string;
  /**
   * the price of the product。后端实际下发的是**字符串**（线上实测 "299.99" / "1.99"）， 此前声明为 number 与线上不符：TS 侧靠满地的 Number(...) 兜住、KMP 侧靠 Json { isLenient = true } 兜住，任一处漏掉即静默出错。按真相声明为 string， 消费方一律显式转数值后再做算术。
   * @example "0.99"
   */
  price?: string;
  /** Raw validity periods configured for this SKU; not a provider billing quote. */
  effective_period?: MemberProductEffectivePeriod[];
  /**
   * is support auto renewal
   * @example true
   */
  auto_renewal?: boolean;
  /** all equities */
  equities?: MemberEquity[];
  /** product type */
  type?: "TRIAL" | "NORMAL" | "REWARD" | "DAPP";
  /** all prices config */
  currencies?: MemberProductCurrency[];
  /** product pay cycle */
  pay_cycle?: "MONTH" | "YEAR" | "WEEK" | "LIFETIME" | "DAY";
  /** product status */
  status?: "ACTIVE" | "HIDDEN" | "DISABLE";
  /** product level */
  level?: MemberProductLevelEnum;
  /**
   * sort
   * @format int32
   */
  sort?: number;
  discount?: {
    /**
     * start time
     * @format int64
     */
    start_time?: number;
    /**
     * end time
     * @format int64
     */
    end_time?: number;
    /**
     * percent off
     * @example 20
     */
    percent_off?: number;
    /**
     * campaign
     * @example "christmas"
     */
    campaign?: string;
  };
  /** renewal product id */
  renewal_id?: string;
  /** Payment configs per channel */
  payment_configs?: MemberProductPaymentConfig[];
}

export type MemberProductResponse = BaseResponse & {
  data?: MemberProduct[];
};

export type RecommendThirdUserPaginationResponse = BaseResponse & {
  data?: RecommendThirdUserPagination;
};

export interface RecommendThirdUserPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: RecommendThirdUser[];
}

/** recommend user info */
export interface RecommendThirdUser {
  /** third user id */
  id?: string;
  /** user handle */
  handle?: string;
  /** user profile image url */
  profile_image_url?: string;
  /**
   * user follow count
   * @format int64
   */
  follow_count?: number;
  /** user display name */
  display_name?: string;
}

export type EquityResponse = BaseResponse & {
  data?: EquityGroups[];
};

export type EquityGrantQuantityResponse = BaseResponse & {
  /**
   * grantable quantity for current equity code
   * @format int32
   */
  data?: number;
};

export type EquityGrantResultResponse = BaseResponse & {
  /** whether grant equity succeeded */
  data?: boolean;
};

export interface EquityGroups {
  internal_category?: string;
  equities?: MemberEquity[];
  /**
   * equity name
   * @example "demo_1"
   */
  name?: string;
  /**
   * equity category
   * @example "Trading Strategy"
   */
  category?: string;
  /**
   * equity weight
   * @format int64
   * @example 1
   */
  weight?: number;
  /** equity remark */
  remark?: string;
}

export interface RedeemCodeResponse {
  redeem_code?: RedeemCode;
}

export interface RedeemCode {
  /**
   * Reward Code, Primary Key
   * @example "MPR-A1B2-C3D4-E5F6"
   */
  code?: string;
  /**
   * Redemption User ID (Filled After Redemption)
   * @example "user123"
   */
  owner_id?: string;
  /**
   * MEMBER, AURA (Filled After Redemption)
   * @example "MEMBER"
   */
  redeemed_type?: any;
  /**
   * Redemption Time (Filled After Redemption)
   * @format int64
   * @example 1634567890000
   */
  redeemed_time?: number;
  /** Redemption Equity */
  redeemed_equity?: object;
  /** Redemption Sub Type */
  sub_type?: string;
  /** Redemption condition */
  redeem_condition?: object;
}

export type RedeemCodePaginationResponse = BaseResponse & {
  data?: RedeemCodePagination;
};

export interface RedeemCodePagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** next page start position */
  next_token?: string;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  rows?: RedeemCode[];
}

/** agent report info */
export interface AgentReport {
  /** report id */
  id?: string;
  /** agent id */
  type?: string;
  /** market */
  market?: string;
  /** asset list */
  assets?: AgentReportAsset[];
  /** category list */
  categories?: AgentReportCategoryEnum[];
  /** agent report content */
  content?: AgentReportContent;
  agent_id?: string;
  /** agent report level */
  level?: AgentReportLevelEnum;
  /** source id list */
  source_ids?: string[];
  /** source agent id list */
  source_agent_ids?: string[];
  /** source link */
  source_link?: string;
  /**
   * created timestamp
   * @format int64
   */
  created?: number;
}

/** agent report content info */
export interface AgentReportContent {
  /**
   * Language code
   * @default "en-US"
   */
  language?: string;
  /** agent report description */
  description?: string;
  /** impact description */
  impact?: string;
  /** content */
  content?: string;
  /** agent report thinking */
  thinking?: string;
  /** agent report level (e.g. A+ to A-, or Sell to Stronger Buy) */
  level?: string;
  /** previous level */
  previous_level?: string;
  /** agent report title */
  title?: string;
  /** agent report summary */
  summary?: string;
  /**
   * time timestamp
   * @format int64
   */
  time?: number;
  /** too long didn't read summary */
  tldr?: string;
  /** table of contents */
  toc?: string;
  /**
   * final score
   * @format double
   */
  final_score?: number;
  /** technical analysis signal */
  ta_signal?: TaSignalDTO;
  /** total cumulative value */
  total_cumulative_value?: string;
  /** total cumulative PnL */
  total_cumulative_pnl?: string;
  /** total cumulative PnL percent */
  total_cumulative_pnl_percent?: string;
  /** today cumulative PnL */
  today_cumulative_pnl?: string;
  /** today cumulative PnL percent */
  today_cumulative_pnl_percent?: string;
  /** total max drawdown */
  total_max_drawdown?: string;
  /** today PnL */
  today_pnl?: string;
  /** Sharpe ratio */
  sharpe_ratio?: string;
}

/** TA indicator DTO */
export interface TAIndicatorDTO {
  /** Indicator name (e.g. MA/RSI/MACD/Stochastic) */
  indicator?: string;
  /** Signal description corresponding to the indicator */
  signal?: string;
  /** Indicator value (as string) */
  value?: string;
  /** Market sentiment */
  sentiment?: string;
  /** Original signal value (for frontend score judgment, e.g. "1" / "-1" / "0") */
  signal_value?: string;
}

/** TA signal DTO */
export interface TaSignalDTO {
  /** List of TA indicator signals */
  ta_signals?: TAIndicatorDTO[];
  /**
   * Trend analysis time timestamp
   * @format int64
   */
  trend_analysis_time?: number;
  /** Trend analysis */
  trend_analysis?: string;
  /**
   * Trend analysis change percent
   * @format double
   */
  trend_analysis_change_percent?: number;
  /** Last SMA values (Map<String, BigDecimal>) */
  last_sma?: Record<string, number>;
  /**
   * Last Stochastic K value
   * @format double
   */
  last_stochastic_k?: number;
  /**
   * Last MACD value
   * @format double
   */
  last_macd?: number;
  /**
   * Price
   * @format double
   */
  price?: number;
  /**
   * 24h price change percent
   * @format double
   */
  change_price_percent_24?: number;
  /** Overall sentiment (Bearish / Bullish / Neutral) */
  sentiment?: string;
}

export interface AgentReportPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: AgentReport[];
}

export type AgentReportPaginationResponse = BaseResponse & {
  data?: AgentReportPagination;
};

export interface ListAgentReportRequest {
  /** agent report category */
  category?: AgentReportCategoryEnum;
  /** agent id list */
  agent_ids?: string[];
  /** include id list */
  ids?: string[];
  levels?: AgentReportLevelEnum[];
  /**
   * content language
   * @default "en-US"
   */
  language?: string;
  /** market */
  market?: string;
  /** @default false */
  count_today?: boolean;
  /**
   * If true, only return reports from the last 24 hours
   * @default false
   */
  last_24h?: boolean;
  /**
   * If true, only return asset-related reports
   * @default false
   */
  asset_only?: boolean;
  enrich?: AgentReportEnrichOption;
  /**
   * page limit
   * @format int32
   * @min 1
   * @max 30
   * @default 20
   */
  limit?: number;
  /** next token for pagination */
  next_token?: string;
}

export type AgentResponse = BaseResponse & {
  data?: Agent[];
};

/** owner preference info */
export interface OwnerPreference {
  /** agent id list */
  agent_ids?: string[];
  /** owner risk level, 1=NEWBIE, 2=CONSERVATIVE, 3=BALANCED, 4=ADVANCED, 5=AGGRESSIVE, 6=SHORT-TERM */
  risk_level?: number;
  /** onboarding investment goals, values=HIGH_GROWTH|STEADY_CASH_FLOW|BUY_UNDERVALUED|LONG_TERM|MOMENTUM */
  investment_goals?: string[];
  /** onboarding followed markets, e.g. US/HK/CRYPTO */
  follow_markets?: string[];
  /** onboarding followed theme ids */
  follow_themes?: string[];
  /** onboarding insight style, values=SIMPLE|BALANCED|PRO */
  insight_style?: string;
  /** Subscribed email push scenes. Key=scene enum (WEEKLY_THEME_RANKING, weekly theme ranking, PRD V3.0.7 theme-rank ad landing US3), value=subscribed email. Merged by key on POST (idempotent, re-submit same scene overwrites the email). */
  subscribed_scenes?: Record<string, string>;
}

export type OwnerPreferenceResponse = BaseResponse & {
  /** owner preference info */
  data?: OwnerPreference;
};

/** add preference request */
export interface AddPreferenceRequest {
  /** agent id list */
  agent_ids?: string[];
  /** owner risk level, 1=NEWBIE, 2=CONSERVATIVE, 3=BALANCED, 4=ADVANCED, 5=AGGRESSIVE, 6=SHORT-TERM */
  risk_level?: number;
  /** onboarding investment goals, values=HIGH_GROWTH|STEADY_CASH_FLOW|BUY_UNDERVALUED|LONG_TERM|MOMENTUM */
  investment_goals?: string[];
  /** onboarding followed markets, e.g. US/HK/CRYPTO */
  follow_markets?: string[];
  /** onboarding followed theme ids */
  follow_themes?: string[];
  /** onboarding insight style, values=SIMPLE|BALANCED|PRO */
  insight_style?: string;
  /** Subscribed email push scenes to merge by key (idempotent, re-submit same scene overwrites the email). Key=scene enum (WEEKLY_THEME_RANKING, weekly theme ranking, PRD V3.0.7 theme-rank ad landing US3), value=subscribed email. Null/omitted means do not update. */
  subscribed_scenes?: Record<string, string>;
  /** Setup checklist celebration modal dismissed flag (PRD V3.1.1 setup checklist AC-4). Once true the celebration modal never shows again on any device; also evicts the onboarding checklist BFF short cache. */
  checklist_celebration_dismissed?: boolean;
}

/** agent info */
export interface Agent {
  /** agent id */
  id?: string;
  /** label */
  label?: string;
  /** agent name */
  name?: string;
  /** description */
  description?: string;
  /** icon */
  icon?: string;
  /** avatar */
  avatar?: string;
  /** agent status */
  status?: AgentStatusEnum;
  /** category list */
  categories?: string[];
  /** default agent */
  default_agent?: boolean;
  /** 0 unsubscribed 1 subscribed */
  subscribe_status?: number;
  risk_level_scope?: number[];
}

export interface AgentSubscriptionPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Agent[];
}

export type AgentSubscriptionPaginationResponse = BaseResponse & {
  data?: AgentSubscriptionPagination;
};

/** subscribe agents request */
export interface SubscribeAgentsRequest {
  /** agent id list */
  agent_ids: string[];
}

export type PositionAccountPaginationResponse = BaseResponse & {
  /** Account pagination information */
  data?: PositionAccountPagination;
};

/** Account pagination information */
export interface PositionAccountPagination {
  /**
   * Total count
   * @format int64
   */
  total?: number;
  rows?: PositionAccount[];
}

/** User account structure */
export interface PositionAccount {
  /**
   * Account ID
   * @example "account123"
   */
  id?: string;
  /** Asset account platform type enumeration */
  platform?: PositionAccountPlatformEnum;
  /**
   * Platform user ID
   * @example "user456"
   */
  platform_user_id?: string;
  /** Account type enumeration */
  account_type?: PositionAccountTypeEnum;
  asset_count?: number;
  /** Asset account platform type enumeration */
  status?: PositionAccountStatusEnum;
  /** broker */
  broker?: string;
  /** @format int64 */
  last_synced_time?: number;
  /**
   * Creation timestamp
   * @format int64
   * @example 1640995200000
   */
  created?: number;
  /**
   * Modification timestamp
   * @format int64
   * @example 1640995200000
   */
  modified?: number;
}

/** Add position request parameters */
export interface AddPositionAssetRequest {
  assets?: AddAsset[];
}

/** Add position request parameters */
export interface AddAsset {
  /**
   * Asset ID
   * @example "bitcoin"
   */
  asset_id: string;
  /** Asset type enumeration */
  asset_type: PositionAssetTypeEnum;
}

export type PositionAssetPaginationResponse = BaseResponse & {
  /** Pagination information */
  data?: PositionAssetPagination;
};

/** Pagination information */
export interface PositionAssetPagination {
  /**
   * Requested data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * Total count
   * @format int32
   */
  total?: number;
  /** Next page token */
  next_token?: string;
  rows?: PositionAsset[];
}

/** Position asset structure */
export interface PositionAsset {
  /**
   * Account ID
   * @example "account123"
   */
  account_id?: string;
  /** Asset type enumeration */
  asset_type?: PositionAssetTypeEnum;
  /**
   * Asset ID
   * @example "bitcoin"
   */
  asset_id?: string;
  /**
   * Owner ID
   * @example "user123"
   */
  owner_id?: string;
  /**
   * Asset name
   * @example "Bitcoin"
   */
  asset_name?: string;
  /** Asset information */
  asset?: AssetInfo;
  /**
   * Creation timestamp
   * @format int64
   * @example 1640995200000
   */
  created?: number;
  /**
   * Modification timestamp
   * @format int64
   * @example 1640995200000
   */
  modified?: number;
  /** amount */
  amount?: number;
  /** previous_close_amount */
  previous_close_amount?: number;
  /** cumulative_fee */
  cumulative_fee?: number;
  /** cumulative_net_buy_value */
  cumulative_net_buy_value?: number;
  /** cumulative_buy_value */
  cumulative_buy_value?: number;
  /** today_increment_fee */
  today_increment_fee?: number;
  /** daily_increment_net_buy_value */
  today_increment_net_buy_value?: number;
  /** daily_increment_buy_value */
  today_increment_buy_value?: number;
  /** avg_cost */
  avg_cost?: number;
}

/** Remove position request parameters */
export interface RemovePositionAssetRequest {
  /**
   * Asset ID
   * @example "bitcoin"
   */
  asset_id: string;
  /** Asset type enumeration */
  asset_type: PositionAssetTypeEnum;
}

/** Add position request parameters */
export interface AddPositionAsset {
  /**
   * Asset ID
   * @example "bitcoin"
   */
  asset_id: string;
  /** Asset type enumeration */
  asset_type: PositionAssetTypeEnum;
}

export interface PositionOrder {
  /** Account ID */
  account_id: string;
  /** Order ID */
  order_id?: string;
  /** Platform */
  platform?: string;
  /** Asset type enumeration */
  asset_type: PositionAssetTypeEnum;
  /** Asset ID */
  asset_id: string;
  /** Order side (buy or sell) */
  side: "BUY" | "SELL";
  /**
   * Order amount
   * @format double
   */
  amount: number;
  /**
   * Order fee
   * @format double
   */
  fee: number;
  /**
   * Order price
   * @format double
   */
  price: number;
  /**
   * Order value
   * @format double
   */
  value: number;
  /**
   * Order creation time (timestamp)
   * @format int64
   */
  order_time?: number;
}

/** Pagination information */
export interface PositionOrderPagination {
  /**
   * Requested data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * Total count
   * @format int32
   */
  total?: number;
  /** Next page token */
  next_token?: string;
  rows?: PositionOrder[];
}

export type PositionOrderPaginationResponse = BaseResponse & {
  /** Pagination information */
  data?: PositionOrderPagination;
};

export interface CreatePositionOrderRequest {
  /** Order side (buy or sell) */
  side: "BUY" | "SELL";
  /** Asset ID */
  asset_id: string;
  /** platform_order_id */
  platform_order_id: string;
  /** Asset type enumeration */
  asset_type: PositionAssetTypeEnum;
  /**
   * Order amount
   * @format double
   */
  amount: number;
  /**
   * Order fee
   * @format double
   */
  fee: number;
  /**
   * Order price
   * @format double
   */
  price: number;
  /**
   * Order creation time (timestamp)
   * @format int64
   */
  order_time: number;
}

export interface PositionCompilation {
  points?: PositionPerformancePoint[];
}

export interface PositionPerformancePoint {
  /**
   * timestamp
   * @format int64
   */
  time?: number;
  /** total cumulative value */
  total_cumulative_value?: number;
  /** total cumulative PnL */
  total_cumulative_pnl?: number;
  /** total cumulative PnL percent */
  total_cumulative_pnl_percent?: number;
}

export type PositionPerformanceResponse = BaseResponse & {
  data?: PositionCompilation;
};

/** Position asset structure */
export interface AssetResponse {
  /**
   * Asset symbol
   * @example "BTC"
   */
  asset_symbol?: string;
  /**
   * Asset logo URL
   * @example "https://example.com/btc.png"
   */
  asset_logo?: string;
}

export type DailyReportDetailResponse = BaseResponse & {
  /** daily report info */
  data?: DailyReport;
};

/** daily report info */
export interface DailyReport {
  /** agent report info */
  agent_report?: AgentReport;
  status?: "GENERATABLE" | "GENERATED";
  /** total cumulative value */
  total_cumulative_value?: number;
  /** total cumulative PnL */
  total_cumulative_pnl?: number;
  /** total cumulative PnL percentage, e.g. 35 (means 35%) */
  total_cumulative_pnl_percent?: number;
  /** today cumulative PnL, e.g. 231 */
  today_cumulative_pnl?: number;
  /** today cumulative PnL percentage, e.g. 12 (means 12%) */
  today_cumulative_pnl_percent?: number;
  /** maximum drawdown, e.g. 15 (means 15%) */
  total_max_drawdown?: number;
  /** Sharpe ratio, e.g. 20 (means 20%) */
  sharpe_ratio?: number;
}

export type SimpleAgentReportResponse = BaseResponse & {
  data?: SimpleAgentReport[];
};

/** simple agent report info */
export interface SimpleAgentReport {
  /**
   * timestamp
   * @format int64
   */
  timestamp?: number;
  /** agent report title */
  title?: string;
  /** agent report description */
  description?: string;
  /** agent report level */
  level?: AgentReportLevelEnum;
  /** source link */
  source_link?: string;
}

export type PositionBrokersResponse = BaseResponse & {
  data?: PositionBroker[];
};

/** Broker configuration for external asset import */
export interface PositionBroker {
  /**
   * Broker ID
   * @format int64
   * @example 100001
   */
  broker_id?: number;
  /**
   * Broker name
   * @example "Alpaca"
   */
  name?: string;
  /**
   * Broker icon URL
   * @format uri
   * @example "https://cdn.ainvest.com/icon/brokers/Alpaca.png"
   */
  broker_icon?: string;
  /**
   * Broker slug identifier
   * @example "ALPACA"
   */
  slug?: string;
  /**
   * Platform type
   * @example "web"
   */
  platform?: string;
  /**
   * Authentication type
   * @example "oauth"
   */
  authType?: string;
  /**
   * Priority order
   * @example 1
   */
  priority?: number;
  /**
   * Supported region
   * @example "US"
   */
  region?: string | null;
  /**
   * Supported crypto region
   * @example null
   */
  "region-crypto"?: string | null;
  /**
   * Broker website URL
   * @format uri
   * @example "https://alpaca.markets"
   */
  "web-site"?: string | null;
  /**
   * Whether this is a paper trading account
   * @example false
   */
  is_paper?: boolean;
  /**
   * category
   * @example "stock crypto"
   */
  category?: string[];
}

export type PlatformConnectResponse = BaseResponse & {
  /** Platform connection information */
  data?: PlatformConnectInfo;
};

/** Platform connection information */
export interface PlatformConnectInfo {
  /**
   * Portal authorization URL for the platform
   * @example "https://portal.snaptrade.com/authorize?client_id=xxx&redirect_uri=xxx"
   */
  portal_url?: string;
  platform_user_id?: string;
  /** Current authorization status */
  authorization_status?: AuthorizationStatusEnum;
  /**
   * Authorization session ID for callback verification
   * @example "session_abc123"
   */
  session_id?: string;
  /**
   * Callback redirect URI
   * @example "https://app.opensocial.xyz/callback"
   */
  redirect_uri?: string;
  /**
   * Authorization expiration timestamp (if already authorized)
   * @format int64
   * @example 1735689600000
   */
  expires_at?: number;
  /**
   * Authorization timestamp (if already authorized)
   * @format int64
   * @example 1735689600000
   */
  authorized_at?: number;
  /**
   * Platform-specific configuration (optional)
   * @example {"scopes":["read:positions","read:orders"],"environment":"production"}
   */
  platform_config?: Record<string, any>;
  /**
   * Remaining number of authorization attempts
   * @format int32
   */
  remain_count?: number;
}

/** Platform authorization request */
export interface PlatformAuthorizationRequest {
  /**
   * brokerageAuthorizationId
   * @example "brokerage_auth_12345"
   */
  brokerage_authorization_id?: string;
  /**
   * apiKey
   * @example "api_key_abc123"
   */
  api_key?: string;
  /**
   * apiSecret
   * @example "api_secret_xyz789"
   */
  api_secret?: string;
  /** accountId */
  account_id?: string;
  platform_user_id?: string;
}

/** Owner position summary request */
export interface OwnerPositionSummaryRequest {
  /** Account IDs to filter */
  account_ids?: string[];
  /** Financial account type (Plaid Account.type) */
  financial_type?: "depository" | "investment" | "credit" | "loan" | "other";
  /**
   * Whether to group by asset
   * @default false
   */
  with_asset_group?: boolean;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  /** Pagination cursor */
  next_token?: string;
  /**
   * Whether to include asset name/symbol
   * @default false
   */
  with_asset?: boolean;
  /**
   * Whether to include owner position performance
   * @default false
   */
  with_position_performance?: boolean;
  /** Performance type */
  performance_type?: "PNL" | "VALUE";
  /** Data aggregation time period. Supported values [1d,7d,30d,90d,180d] */
  performance_period?: string;
  /** Filter by connection ID */
  connection_id?: string;
}

/** Asset group aggregation result */
export interface AssetGroupDTO {
  /** Asset identifier */
  asset_id?: string;
  /** Asset type */
  asset_type?: string;
  /** Aggregated amount (as string for precision) */
  total_amount?: string;
  /** Source account IDs */
  account_ids?: string[];
  /**
   * Number of source accounts
   * @format int32
   */
  account_count?: number;
  /** Asset name (when with_asset=true) */
  asset_name?: string;
  /** Asset symbol (when with_asset=true) */
  asset_symbol?: string;
}

/** Owner position summary data */
export interface OwnerPositionSummaryData {
  /** Aggregated asset groups */
  asset_groups?: AssetGroupDTO[];
  /**
   * Page size
   * @format int32
   */
  limit?: number;
  /** Next page token */
  next_token?: string;
  position_performance?: PositionPerformance;
}

export interface PositionPerformance {
  points?: PositionPerformancePoint[];
}

export type OwnerPositionSummaryResponse = BaseResponse & {
  /** Owner position summary data */
  data?: OwnerPositionSummaryData;
};

export type PlatformAuthorizationResponse = BaseResponse & {
  /** Created or updated account information */
  data?: PositionAccount;
};

/** Request to sync position data from third-party platform */
export interface SyncPositionDataRequest {
  /**
   * Whether to sync position assets (holdings)
   * @default true
   * @example true
   */
  sync_assets?: boolean;
  /**
   * Whether to sync orders
   * @default true
   * @example true
   */
  sync_orders?: boolean;
  /**
   * Force refresh even if data was recently synced
   * @default false
   * @example false
   */
  force_refresh?: boolean;
}

export type SyncPositionDataResponse = BaseResponse & {
  /** Position data synchronization result */
  data?: SyncPositionDataInfo;
};

/** Position data synchronization result */
export interface SyncPositionDataInfo {
  /** User account structure */
  account?: PositionAccount;
  /** Overall synchronization status */
  sync_status?: SyncStatusEnum;
  /**
   * Synchronization start timestamp
   * @format int64
   * @example 1640995200000
   */
  sync_started_at?: number;
  /**
   * Synchronization completion timestamp
   * @format int64
   * @example 1640995300000
   */
  sync_completed_at?: number;
  /**
   * Overall error message if synchronization failed
   * @example ""
   */
  error_message?: string;
}

/** Get opportunity summary request */
export interface GetOpportunitySummaryRequest {
  /** Winning rate types to include */
  types?: OpportunityTypeEnum[];
  /**
   * Market filter (e.g., US, HK)
   * @default "US"
   */
  market?: string;
}

export type OpportunitySummaryResponse = BaseResponse & {
  data?: OpportunitySummary[];
};

/** Opportunity summary with total return */
export interface OpportunitySummary {
  /** Business type */
  type?: OpportunityTypeEnum;
  /**
   * Winning rate (percentage)
   * @format double
   */
  winning_rate?: number;
  /** Total return sparkline data (180-day performance chart) */
  total_returns?: PricePoint[];
  /** index return sparkline data (180-day performance chart) */
  index_returns?: PricePoint[];
  /**
   * gifted count
   * @format int32
   */
  gifted_count?: number;
}

/** List opportunities request */
export interface ListOpportunitiesRequest {
  /** Business type */
  type?: OpportunityTypeEnum;
  /** Status filter */
  status?: OpportunityStatusEnum;
  /** Enrichment options */
  enrich?: OpportunityEnrichOption;
  /**
   * Language code (e.g., en-US, zh-CN)
   * @default "en-US"
   */
  language?: string;
  /**
   * Page limit
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  /** Next token for pagination */
  next_token?: string;
  /** stock status */
  asset_status?: "APPLYING" | "PENDING" | "LISTED";
  /**
   * Start time
   * @format int64
   * @example 1632899200000
   */
  start_time?: number;
  /**
   * End time
   * @format int64
   */
  end_time?: number;
  /**
   * Market filter (e.g., US, HK)
   * @default "US"
   */
  market?: string;
}

/** Opportunity enrich option for list API (without performance data) */
export interface OpportunityListEnrichOption {
  /**
   * Whether to enable data enrichment
   * @default false
   */
  enable?: boolean;
  with_asset?: {
    /**
     * Whether to return asset detailed information (logo, current_price)
     * @default false
     */
    enable?: boolean;
    /** Whether to return price */
    with_price?: boolean;
  };
}

export type OpportunityPaginationResponse = BaseResponse & {
  /** Opportunity pagination data */
  data?: OpportunityPagination;
};

/** Opportunity pagination data */
export interface OpportunityPagination {
  /**
   * Page limit
   * @format int32
   * @min 1
   * @max 50
   */
  limit?: number;
  /**
   * Total count
   * @format int64
   */
  total_count?: number;
  /** Next token for pagination */
  next_token?: string;
  /** Opportunity list */
  rows?: Opportunity[];
}

/** Opportunity information */
export interface Opportunity {
  /** Opportunity ID */
  id?: string;
  /** Business type */
  type?: OpportunityTypeEnum;
  /** Asset information */
  asset?: OpportunityAsset;
  /** Status */
  status?: OpportunityStatusEnum;
  /**
   * Entry price
   * @format decimal
   */
  entry_price?: number;
  /**
   * Stop loss price
   * @format decimal
   */
  stop_loss_price?: number;
  /**
   * Expected return rate (percentage)
   * @format decimal
   */
  expected_return?: number;
  /**
   * Current return rate (percentage)
   * @format decimal
   */
  current_return?: number;
  /** AI summary of selection reason */
  reason?: string;
  /**
   * reason time
   * @format int64
   */
  reason_time?: number;
  /** theme recommend reason */
  theme_reason?: string;
  /**
   * Entry date timestamp (milliseconds)
   * @format int64
   */
  entry_date?: number;
  /**
   * Exit price (null if not exited)
   * @format decimal
   */
  exit_price?: number;
  /**
   * Exit date timestamp (null if not exited)
   * @format int64
   */
  exit_date?: number;
  /**
   * Exit return rate (null if not exited)
   * @format decimal
   */
  exit_return?: number;
  /**
   * Earnings report date timestamp (milliseconds, for EARNINGS type)
   * @format int64
   */
  report_date?: number;
  /**
   * Predicted price change percentage (for EARNINGS type)
   * @format decimal
   */
  price_change_prediction?: number;
  /** EPS prediction result (for EARNINGS type) */
  eps_prediction?: "STRONG_BEAT" | "BEAT" | "NEUTRAL" | "MISS" | "STRONG_MISS";
  /** Revenue prediction result (for EARNINGS type) */
  revenue_prediction?:
    "STRONG_BEAT" | "BEAT" | "NEUTRAL" | "MISS" | "STRONG_MISS";
  /**
   * Estimated EPS (for EARNINGS type, reference only)
   * @format decimal
   */
  eps_estimate?: number;
  /**
   * Estimated revenue (for EARNINGS type, reference only)
   * @format decimal
   */
  revenue_estimate?: number;
  /** Earnings call information (for EARNINGS type) */
  earnings_call?: {
    /** Earnings call title (e.g., "Q2 2024 Performance Key Points"). Generated automatically based on fiscal year and quarter information from the transcript. */
    title?: string;
    /** Earnings call transcripts content (Markdown format). Contains the original transcript content from FMP API or AI-generated summary. Retrieved by scheduled task after earnings release time. */
    transcripts?: string;
  };
  /**
   * Actual EPS (for EARNINGS type)
   * @format decimal
   */
  eps_actual?: number;
  /**
   * Actual revenue (for EARNINGS type)
   * @format decimal
   */
  revenue_actual?: number;
  /** EPS actual result rating compared to estimate (for EARNINGS type) */
  eps_actual_result?:
    "STRONG_BEAT" | "BEAT" | "NEUTRAL" | "MISS" | "STRONG_MISS";
  /** Revenue actual result rating compared to estimate (for EARNINGS type) */
  revenue_actual_result?:
    "STRONG_BEAT" | "BEAT" | "NEUTRAL" | "MISS" | "STRONG_MISS";
  /**
   * Actual price change percentage (calculated from report_previous_close and report_week_price, for EARNINGS type)
   * @format decimal
   */
  price_change_actual?: number;
  /**
   * Previous closing price before earnings report (base price for calculating price change, for EARNINGS type)
   * @format decimal
   */
  report_previous_close?: number;
  /**
   * Closing price in trading days 1-6 after earnings report (always stores the latest trading day closing price, for EARNINGS type)
   * @format decimal
   */
  report_week_price?: number;
  /** Report details (null if not generated) */
  report?: OpportunityReport;
  /** Impact information array (returned when enrich_option.with_impact=true) */
  impact?: OpportunityImpact[];
  /**
   * Creation timestamp (milliseconds)
   * @format int64
   */
  created?: number;
  /**
   * Modification timestamp (milliseconds)
   * @format int64
   */
  modified?: number;
  /** ai operation advice */
  operation_advice?: string;
  /**
   * Potential return rate
   * @format double
   */
  potential_return?: number;
  /** Unlock status */
  unlock_status?: "LOCKED" | "UNLOCKED";
}

/** Opportunity asset information */
export interface OpportunityAsset {
  /** Stock symbol */
  symbol?: string;
  /** Asset ID (e.g., XNAS_AAPL) */
  id?: string;
  /** Asset type */
  type?: "STOCK" | "TOKEN";
  /** Asset logo URL */
  logo?: string;
  /**
   * Current price
   * @format double
   */
  current_price?: number;
  /** Asset name */
  name?: string;
  themes?: {
    /** theme id */
    id?: string;
    /** theme name */
    theme?: string;
    /** theme slug */
    slug?: string;
    /** theme market */
    market?: string;
  }[];
  ipo?: StockIpo;
}

export interface Media {
  /** id for resource */
  id?: string;
  /** media url */
  display_url?: string;
  /** media url */
  media_url?: string;
  /** http url */
  media_url_https?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
  /** native/twitter/giphy */
  source?: string;
  /** link */
  link?: string;
  /** url */
  url?: string;
  /** json format sizes */
  sizes?: string;
  /** extra cover url */
  extra?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  mime_type?: string;
  /** cover url */
  cover?: string;
}

/** Opportunity report details */
export interface OpportunityReport {
  /** Rating dimensions grouped by level */
  dimensions?: OpportunityReportDimension[];
}

/** Report dimension with level and contents */
export interface OpportunityReportDimension {
  /** Rating level (A+/A/A-/B+/B/B-/C+/C/C-) */
  level?: string;
  /** Content type,0-final,1~xxx-other */
  type?: string;
  /** content */
  content?: string;
  /**
   * content update timestamp
   * @format int64
   */
  timestamp?: number;
}

/** Opportunity impact information */
export interface OpportunityImpact {
  /** Impact viewpoint */
  viewpoint?: string;
  /** Impact description */
  impact?: string;
}

/** Get opportunity detail request */
export interface GetOpportunityRequest {
  /** List of Opportunity IDs */
  ids?: string[];
  /** Enrichment options (detail) */
  enrich?: OpportunityEnrichOption;
  /**
   * Language code (e.g., en-US, zh-CN)
   * @default "en-US"
   */
  language?: string;
  /**
   * Whether to require unlock for the opportunity
   * @default false
   */
  require_unlock?: boolean;
}

/** Opportunity detail enrich option */
export interface OpportunityDetailEnrichOption {
  /**
   * Whether to enable data enrichment
   * @default false
   */
  enable?: boolean;
  /**
   * Whether to return impact information
   * @default false
   */
  with_impact?: boolean;
}

export type OpportunityResponse = BaseResponse & {
  data?: Opportunity[];
};

export interface PricePoint {
  /**
   * The timestamp of the sparkline
   * @format int64
   */
  timestamp?: number;
  price?: number;
}

export interface StockIpo {
  /**
   * Apply start time
   * @format int64
   */
  apply_start_time?: number;
  /**
   * Apply end time
   * @format int64
   */
  apply_end_time?: number;
  /**
   * IPO price
   * @format double
   */
  ipo_price?: number;
  /**
   * Dark trade start time
   * @format int64
   */
  dark_trade_start_time?: number;
  /**
   * Dark trade end time
   * @format int64
   */
  dark_trade_end_time?: number;
  /**
   * IPO time
   * @format int64
   */
  ipo_time?: number;
  coordinators?: StockIpoParticipant[];
  sponsors?: StockIpoParticipant[];
  /**
   * Subscription multiple
   * @format double
   */
  subscription_multiple?: number;
  /**
   * First day max price change percent
   * @format double
   */
  first_day_max_price_change_percentage?: number;
  /**
   * First day high price
   * @format double
   */
  first_day_high_price?: number;
  /**
   * Dark trade close price
   * @format double
   */
  dark_trade_close_price?: number;
  /**
   * Dark trade price change percent
   * @format double
   */
  dark_trade_price_change_percent?: number;
}

export interface StockIpoParticipant {
  /** The name of the participant */
  name?: string;
  /** The avatar of the participant */
  avatar?: string;
  /**
   * The win rate of the participant
   * @format double
   */
  win_rate?: number;
}

/** Opportunity enrich option */
export interface OpportunityEnrichOption {
  /**
   * Whether to enable data enrichment
   * @default false
   */
  enable?: boolean;
  with_asset?: {
    /**
     * Whether to return asset detailed information (logo, current_price)
     * @default false
     */
    enable?: boolean;
    /** Whether to return price */
    with_price?: boolean;
    /** Whether to return ipo */
    with_ipo?: boolean;
    /** Whether to return theme info */
    with_theme?: boolean;
  };
  /**
   * Whether to return impact information
   * @default false
   */
  with_impact?: boolean;
}

export interface MemberProductPaymentConfig {
  /** Channel identifier, e.g. IAB (Google Play), IAP (Apple IAP) */
  channel?: string;
  /** Channel config status, ACTIVE (enabled), INACTIVE (disabled) */
  status?: string;
  /** Store product ID for this channel (Apple product_id, Google Play product ID) */
  product_id?: string;
  /** Store plan ID for this channel (Google plan_id, Google Play plan_id ID) */
  plan_id?: string;
  /**
   * Discount percentage based on original price (0-100), for frontend display. e.g., 20 means 20% off, actual price is 80% of original price
   * @format int32
   * @example 20
   */
  discount_percent?: number;
  /** List of offers supported by this channel */
  offers?: MemberProductPaymentConfigOffer[];
  /** Client platforms this channel is offered on (WEB / IOS / ANDROID); defaults by channel type when not configured */
  platforms?: string[];
  /** Channel display name; clients use it as the button label for channels they have no built-in label for */
  display_name?: string;
}

export interface MemberProductPaymentConfigOffer {
  /** Offer status, ACTIVE (enabled), INACTIVE (disabled) */
  status?: string;
  /** Offer code, e.g. intro_free_trial_7d (Apple), google_offer_free_7d (Google) */
  code?: string;
  /** Offer type, introductory or promotional */
  type?: string;
  /** Display name, e.g. 7-day free trial */
  reference_name?: string;
  /**
   * Configured trial duration in days
   * @format int64
   */
  trial_period_days?: number;
}

export interface PaymentCheckRequest {
  /**
   * Product identifier (e.g. expert_subscription); opensocial calls kmember for eligibility and mixture for signing
   * @example "expert_subscription"
   */
  product_id: string;
  /** Payment channel (e.g. IAP) */
  pay_channel: PayChannel;
  /** Application context for the transaction. */
  payment_context?: PaymentContext;
  /** token usage */
  pay_type?: PayType;
  /** Checkout UI mode; HOSTED redirects to the provider page, EMBEDDED returns client_secret */
  checkout_ui_mode?: CheckoutUiMode;
  /** Click-through consent captured before checkout; required for subscription and trial products */
  consent?: PaymentConsent;
}

/** Click-through consent captured before checkout; required for subscription and trial products */
export interface PaymentConsent {
  /** Consent copy version */
  version: string;
  /** Must be true */
  accepted: boolean;
}

export type PaymentCheckResponse = BaseResponse & {
  /** payment/check response data; when eligible includes owner_external_ref and productId; when not eligible only offer_details[].eligible=false */
  data?: PaymentCheckResponseData;
};

/** payment/check response data; when eligible includes owner_external_ref and productId; when not eligible only offer_details[].eligible=false */
export interface PaymentCheckResponseData {
  /** Array of offer details (eligible, code, sign) for client to initiate purchase with the store */
  offer_details?: OfferDetail[];
  /** User binding (UUID from encode(ownerId)), to be passed as appAccountToken; used for webhook lookup */
  owner_external_ref?: string;
  /** Product identifier, same as request (e.g. expert_subscription) */
  product_id?: string;
  /** Purchase token for the previous purchase plan, if exist */
  old_purchase_token?: string;
}

/** Single offer detail item */
export interface OfferDetail {
  /** Whether the user is eligible for this offer */
  eligible?: boolean;
  /** Offer code (e.g. FREE_7_TRIAL) */
  code?: string;
  /** Signing info (returned when eligible) */
  sign?: OfferDetailSign;
  /** Payment provider links for this offer (e.g. Stripe Checkout URL) */
  links?: Link[];
  /** Checkout session id; used as purchase_token of /payment/confirm */
  session_id?: string;
  /** Returned only for EMBEDDED checkout */
  client_secret?: string;
}

/** Offer signing info for client to initiate purchase with the store */
export interface OfferDetailSign {
  /** Key ID from App Store Connect */
  key_id?: string;
  /** UUID generated by backend */
  nonce?: string;
  /** Signature computed by backend for store verification */
  signature?: string;
  /**
   * Timestamp in milliseconds
   * @format int64
   */
  timestamp?: number;
}

export interface PaymentConfirmRequest {
  /** Transaction ID from the store (transactionId in JWS or Transaction Info) */
  purchase_token: string;
  /** Payment channel (e.g. IAP); maps to payment_plan.pay_channel for persistence and analytics */
  pay_channel: PayChannel;
  /** Product ID */
  product_id?: string;
}

export type PaymentConfirmResponse = BaseResponse & {
  /** payment/confirm response data */
  data?: PaymentConfirmResponseData;
};

/** payment/confirm response data */
export interface PaymentConfirmResponseData {
  /** result */
  result?: boolean;
}

export type CikResponse = BaseResponse & {
  /** CIK investor list */
  data?: Cik[];
  /** Total number of CIK investors matching the query */
  total?: number;
};

/** CIK featured investor data */
export interface Cik {
  /**
   * CIK number
   * @example "1067983"
   */
  cik?: string;
  /**
   * Investor name
   * @example "Berkshire Hathaway"
   */
  name?: string;
  /**
   * Investor description
   * @example "Warren Buffett's investment company"
   */
  desc?: string;
  /**
   * Avatar URL
   * @example "https://xxx.com/avatar.png"
   */
  avatar?: string;
  /**
   * Latest position date (quarter end, format YYYY-MM-DD)
   * @example "2025-06-30"
   */
  date?: string;
  /** CIK portfolio change percentage. Key is time period (e.g. 30d, 7d), value is change percentage. */
  change?: CikChangePercentage;
  top_change_positions?: CikAssetPosition[];
  top_value_positions?: CikAssetPosition[];
}

/**
 * CIK portfolio change percentage. Key is time period (e.g. 30d, 7d), value is change percentage.
 * @example {"30d":0.05,"7d":0.02}
 */
export type CikChangePercentage = Record<string, number>;

/** CIK asset position detail */
export interface CikAssetPosition {
  /**
   * Asset ID, null if stock not found in system
   * @example "asset_123"
   */
  asset_id?: string;
  /**
   * Asset type
   * @example "STOCK"
   */
  asset_type?: string;
  /**
   * Stock symbol
   * @example "AAPL"
   */
  cik_symbol?: string;
  /**
   * Stock name
   * @example "AAPL"
   */
  name_of_issuer?: string;
  /**
   * Asset logo URL
   * @example "https://..."
   */
  logo?: string;
  /**
   * Position amount (shares)
   * @example 280000000
   */
  amount?: number;
  /**
   * Position value in USD
   * @example 57447600000
   */
  value?: number;
  /**
   * Position weight ratio
   * @example 0.45
   */
  weight?: number;
  /** CIK position change type enumeration */
  change_type?: CikChangeTypeEnum;
  /**
   * Change amount (positive for increase, negative for decrease)
   * @example -15000000
   */
  change_amount?: number;
  /** Asset information */
  asset?: AssetInfo;
}

export type CikPositionDetailResponse = BaseResponse & {
  /** Position assets list */
  data?: CikAssetPosition[];
  /** Token for fetching the next page of results, null if no more data */
  next_token?: string;
};

/** CIK with asset option */
export interface PositionAssetEnrichOption {
  /**
   * Whether to return asset detailed information (logo, current_price)
   * @default false
   */
  with_asset?: boolean;
}

/** Asset information */
export interface AssetInfo {
  /**
   * Asset symbol
   * @example "BTC"
   */
  asset_symbol?: string;
  /**
   * Asset logo URL
   * @example "https://example.com/btc.png"
   */
  asset_logo?: string;
  /**
   * Asset Market
   * @example "US/HK"
   */
  asset_market?: string;
}

export interface AgentReportEnrichOption {
  /**
   * If you need to return the token relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** @default false */
  with_content?: boolean;
  with_asset?: AssetEnrichOption;
}

export interface AssetEnrichOption {
  /**
   * If you need to return the post relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** @default false */
  with_price?: boolean;
}

/** asset info */
export interface AgentReportAsset {
  /** asset id */
  id?: string;
  /** asset symbol */
  symbol?: string;
  /** logo */
  logo?: string;
  /** asset type */
  type?: string;
  /** coin price change 24h */
  price_change_24h?: number;
  /** The current price of the stock */
  current_price?: number;
  /** The previous close price of the stock */
  previous_close?: number;
  /** stock short name */
  short_name?: string;
  /** stock symbol company name */
  company_name?: string;
}

export interface Inviter {
  /** inviter display name */
  nick_name?: string;
  /** inviter avatar url */
  avatar?: string;
}

export interface InviteValidation {
  /** whether the invite code can be bound on registration */
  valid?: boolean;
  inviter?: Inviter;
}

export type InviteValidationResponse = BaseResponse & {
  data?: InviteValidation;
};

export interface SendCodeRequest {
  /** code type, e.g. email */
  type: "EMAIL";
  /** email address */
  email: string;
}

export interface CreatePaymentPlanRequest {
  /**
   * product id to purchase
   * @example "pro_month"
   */
  product_id?: string;
  /** Application context for the transaction. */
  payment_context?: PaymentContext;
  /** token usage */
  pay_type?: PayType;
  /** Payment channel */
  pay_channel?: PayChannel;
}

/** Application context for the transaction. */
export interface PaymentContext {
  /**
   * Brand name displayed on PayPal checkout page.
   * @example "YourBrand"
   */
  brand_name?: string;
  /**
   * Locale for checkout page (e.g., en-US).
   * @example "en-US"
   */
  locale?: string;
  /**
   * Shipping preference for the subscription.
   * @example "NO_SHIPPING"
   */
  shipping_preference?:
    "NO_SHIPPING" | "GET_FROM_FILE" | "SET_PROVIDED_ADDRESS";
  /**
   * User action for checkout (SUBSCRIBE_NOW triggers immediate payment).
   * @example "SUBSCRIBE_NOW"
   */
  user_action?: "SUBSCRIBE_NOW" | "CONTINUE";
  /**
   * URL to redirect after successful payment.
   * @format uri
   * @example "https://example.com/success"
   */
  return_url?: string;
  /**
   * URL to redirect after payment cancellation.
   * @format uri
   * @example "https://example.com/cancel"
   */
  cancel_url?: string;
}

export type PaymentPlanResponse = BaseResponse & {
  data?: PaymentPlan;
};

export interface PaymentPlan {
  /** Payment ID */
  id?: string;
  /** Business ID */
  business_id?: string;
  /** Business type */
  business_type?: PayBusinessType;
  /** Subscription owner ID */
  owner_id?: string;
  /** token usage */
  pay_type?: PayType;
  /** Payment channel */
  pay_channel?: PayChannel;
  /** pay status */
  status?: PaymentPlanStatus;
  /** Subscription sub status */
  sub_status?: string;
  /**
   * Start time
   * @format int64
   */
  start_time?: number;
  /**
   * End time
   * @format int64
   */
  end_time?: number;
  /**
   * Next billing time
   * @format int64
   */
  next_billing_time?: number;
  /**
   * Outstanding balance (arrears), decimal string for precision
   * @format int64
   */
  outstanding_balance?: number;
  /** Payment failure attempts */
  failure_attempts?: number;
  /** Paypal approval links, valid for 3 hours after creation */
  links?: Link[];
  /** member product level */
  product_level?: MemberProductLevelEnum;
  /** Management actions supported by this subscription; absent on legacy responses */
  capabilities?: SubscriptionCapability[];
  /** Whether the subscription renews at period end */
  auto_renew?: boolean;
  /** Outstanding payment problem, null when none */
  payment_issue?: "PAYMENT_FAILED" | null;
  /**
   * Current billing period end in milliseconds
   * @format int64
   */
  current_period_end?: number;
}

export interface PlanUpdateRequest {
  /** false turns off auto-renew at period end, true resumes it */
  auto_renew: boolean;
}

export interface PaymentMethodSessionCreateRequest {
  /** Checkout UI mode; HOSTED redirects to the provider page, EMBEDDED returns client_secret */
  ui_mode?: CheckoutUiMode;
  /** URL to redirect after the payment method is saved */
  return_url: string;
  /** URL to redirect when the user leaves without saving */
  back_url?: string;
  /** BCP-47 language of the hosted page (en-US, zh-TW); empty lets the channel pick from the browser */
  locale?: string;
}

export interface PaymentMethodSession {
  session_id?: string;
  /** Hosted page URL (HOSTED) */
  url?: string;
  /** Returned only for EMBEDDED */
  client_secret?: string;
  status?: "PENDING" | "APPLIED" | "EXPIRED";
  /** @format int64 */
  expires_at?: number;
}

export type PaymentMethodSessionResponse = BaseResponse & {
  data?: PaymentMethodSession;
};

export interface PlanChangeRequest {
  /** Product to switch to; charged at full price today and the billing period restarts */
  target_product_id: string;
  /** Click-through consent captured before checkout; required for subscription and trial products */
  consent?: PaymentConsent;
}

export interface PlanChangeResult {
  status?: "SUCCEEDED" | "REQUIRES_PAYMENT_METHOD" | "PENDING";
  plan?: PaymentPlan;
}

export type PlanChangeResultResponse = BaseResponse & {
  data?: PlanChangeResult;
};

export interface Link {
  /**
   * URL for the action
   * @example "https://api.paypal.com/v1/billing/subscriptions/S-9876543210ZYXWVUT"
   */
  href?: string;
  /**
   * Link relation (e.g., self, edit)
   * @example "self"
   */
  rel?: string;
  /**
   * HTTP method for the link
   * @example "GET"
   */
  method?: "GET" | "POST" | "PATCH" | "DELETE";
}

export interface ListPaymentPlanRequest {
  /** Next token */
  next_token?: string;
  /** Limit */
  limit?: number;
  /** Status */
  status?: PaymentPlanStatus[];
  /** Business type */
  business_type?: PayBusinessType;
  /** payment plan ID */
  id?: string;
  /** token usage */
  pay_type?: PayType;
  /** Payment channel */
  pay_channel?: PayChannel;
}

export type PaymentPlanPaginationResponse = BaseResponse & {
  data?: PaymentPlanPagination;
};

export interface PaymentPlanPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int64 */
  total?: number;
  next_token?: string;
  rows?: PaymentPlan[];
}

export interface GetMemberRequest {
  enrich?: MemberEnrichOption;
}

export interface MemberEnrichOption {
  /**
   * if you need to return the credit balance information, set this to true (default). Set to false to skip credit query. Only available for active members with credit-enabled products.
   * @default true
   */
  with_credit?: boolean;
  /** scenario code */
  scenarioCode?: string;
  /**
   * if you need to return available_products , set this to true (default).
   * @default true
   */
  with_available_products?: boolean;
}

export interface ListPaymentRecordRequest {
  /** Owner ID */
  owner_id?: string;
  /** Next token */
  next_token?: string;
  /** Limit */
  limit?: number;
  /** Status */
  status?: string[];
  /** Business type */
  business_type?: PayBusinessType;
  /** Pay channel */
  pay_channel?: PayChannel;
  business_types?: PayBusinessType[];
}

export type PaymentRecordPaginationResponse = BaseResponse & {
  data?: PaymentRecordPagination;
};

export interface PaymentRecordPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int64 */
  total?: number;
  next_token?: string;
  rows?: PaymentRecord[];
}

export interface PaymentRecord {
  /** Subscriber ID */
  id?: string;
  /** Business type */
  business_type?: PayBusinessType;
  /** Business ID */
  business_id?: string;
  /** Payment ID */
  payment_id?: string;
  /** Subscriber owner ID */
  owner_id?: string;
  /** Payer ID */
  payer?: string;
  /** Amount */
  amount?: number;
  currency?: PaymentCurrency;
  /** Payment channel */
  channel?: PayChannel;
  /**
   * Payment time
   * @format int64
   */
  payment_time?: number;
  /**
   * Charge fee
   * @format double
   */
  charge_fee?: number;
  /** Payment status */
  status?: string;
  /** Product ID */
  product_id?: string;
  /** Detail */
  detail?: string;
  /** Record type */
  record_type?: string;
  /** Refunded record ID */
  refunded_record_id?: string;
  /** Applied offers */
  applied_offers?: string;
}

export interface PaymentCurrency {
  /** type */
  type?: string;
  /** address */
  address?: string;
  /** currency */
  currency?: string;
  /** chainId */
  chain_id?: string;
  /** ecosystem */
  ecosystem?: string;
}

export type MemberRetentionStatsResponse = BaseResponse & {
  data?: MemberRetentionStats;
};

export interface MemberRetentionStats {
  owner_id?: string;
  /** @format int64 */
  effect_time?: number;
  /** @format int64 */
  expire_time?: number;
  member_days?: number;
  /** @format int64 */
  chat_count?: number | null;
  /** @format int64 */
  signal_count?: number | null;
  /** @format int64 */
  alpha_earning_count?: number | null;
  /** @format int64 */
  alpha_ipo_count?: number | null;
  /** @format int64 */
  alpha_ai_pick_count?: number | null;
  /** @format int64 */
  report_daily_report_count?: number | null;
  /** @format int64 */
  report_report_360_count?: number | null;
  /**
   * @maxItems 3
   * @minItems 3
   */
  summary?: string[];
  /** @format int64 */
  updated_at?: number;
}

export interface Challenge {
  /** text to sign */
  text?: string;
}

export type ChallengeResponse = BaseResponse & {
  data?: Challenge;
};

export interface AccessToken {
  /** 30 minutes access token */
  access_token?: string;
  /** 7 days refresh token */
  refresh_token?: string;
}

export type TokenResponse = BaseResponse & {
  data?: AccessToken;
};

export interface AuthRequest {
  /** sign message by challenge text */
  signature: string;
  /** address */
  eoa_address: string;
  /** IssuePlatform */
  issue_platform?: string;
  /** Issue Channel such as WALLET, FIREBASE */
  issue_channel?: string;
}

export interface IdToken {
  /** the user identifier token */
  id_token?: string;
}

export type IdTokenResponse = BaseResponse & {
  data?: IdToken;
};

export type OwnerResponse = BaseResponse & {
  /** Owner info */
  data?: Owner;
};

export interface OwnerPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Owner[];
}

export type OwnerPaginationResponse = BaseResponse & {
  data?: OwnerPagination;
};

/** query relation */
export interface ListRelationRequest {
  /**
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  next_token?: string;
  /** @maxItems 20 */
  include_target_ids?: string[];
  /** relation ranking enum */
  ranking?: RelationRankingEnum;
  user_name?: string;
  level?: string;
  reverse?: boolean;
}

export interface WalletSignRequest {
  /**
   * The EOA address to receive the rebate
   * @example "0x1234567890123456789012345678901234567890"
   */
  eoa_address?: string;
  /**
   * rebate type
   * @example "MEMBER"
   */
  type?: string;
  /** sign type example PAYMENT,CLAIM */
  sign_type?: string;
  /** Payment product id (member) */
  product_id?: string;
  /** @format int32 */
  chain_id?: number;
  /** The token address */
  token_address?: string;
}

export type WalletSignResponse = BaseResponse & {
  data?: WalletSign;
};

export interface WalletSign {
  /** call data */
  call_data?: string;
  /** value */
  value?: string;
  /** target address */
  target_address?: string;
}

export interface SyncRequest {
  tx_hash?: string;
  uo_hash?: string;
  topic?: string;
  index_id?: string;
  off_chain_id?: string;
  chain_id?: string;
  status?: "SUCCESS" | "FAIL" | "BEGIN";
}

export type TransactionResponse = BaseResponse & {
  data?: {
    /** txHash if success */
    tx_hash?: string;
    /** txId if indexed by relay */
    tx_id?: string;
    info?: object;
  };
};

export type RebatePaginationResponse = BaseResponse & {
  data?: RebatePagination;
};

export interface RebatePagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Rebate[];
}

export interface Rebate {
  /** Owner info */
  giver?: Owner;
  /** Rebate amount */
  amount?: number;
  /**
   * rebate create time
   * @format int64
   */
  created?: number;
}

export type RebateSummaryResponse = BaseResponse & {
  data?: RebateSummary;
};

export interface RebateSummary {
  /** pending amount */
  pending_amount?: number;
  /** claimed amount */
  claimed_amount?: number;
  /** claimable amount */
  claimable_amount?: number;
}

/** Third-party connection authorization callback request. Legacy Position fields (SnapTrade/OKX/Binance) plus Plaid Financial Planner fields.  */
export interface FinancialAuthorizationRequest {
  /**
   * SnapTrade brokerage authorization ID
   * @example "brokerage_auth_12345"
   */
  brokerage_authorization_id?: string;
  /**
   * API key (OKX/Binance etc.)
   * @example "api_key_abc123"
   */
  api_key?: string;
  /**
   * API secret (OKX/Binance etc.)
   * @example "api_secret_xyz789"
   */
  api_secret?: string;
  /** Account ID; optional for update mode audit */
  account_id?: string;
  /** Platform user ID */
  platform_user_id?: string;
  /** Plaid Link onSuccess public_token (Financial Planner) */
  public_token?: string;
  /** Institution ID from Plaid Link metadata */
  institution_id?: string;
  /** Institution name from Plaid Link metadata */
  institution_name?: string;
  /** Plaid Link token for update mode (Financial Planner) */
  link_token?: string;
  /**
   * Client platform: ios / android / web / h5
   * @example "android"
   */
  client_type?: string;
}

export interface FinancialConnectionResponse {
  /**
   * sub code
   * @format int32
   */
  code?: number;
  /** information for the response */
  msg?: string;
  /** Third-party financial connection */
  data?: FinancialConnection;
  errors?: Error[];
}

/** Third-party financial connection */
export interface FinancialConnection {
  /** Internal connection ID */
  connection_id?: string;
  /**
   * Platform code (PLAID, MANUAL, etc.)
   * @example "PLAID"
   */
  platform?: string;
  /** Plaid item_id */
  platform_connection_id?: string;
  /** Institution ID */
  institution_id?: string;
  /** Institution display name */
  institution_name?: string;
  /** Institution logo URL / Base64 image */
  institution_logo?: string;
  /**
   * Connection auth health: 0=active, 1=auth_expire (Plaid auth expired, re-link needed), 2=deleted (legacy 3→deleted). NOTE: plaid trial-window state is a separate derived field `plaid_status` on this connection (trial/expired), NOT this status.
   * @format int32
   */
  status?: number;
  /**
   * Plaid trial-window state (time-derived, owner-level same value on each PLAID connection). Absent when list `data` is empty (never linked). Orthogonal to `status` (auth health).
   * @example "trial"
   */
  plaid_status?: "trial" | "expired";
  /**
   * Linked timestamp (epoch ms)
   * @format int64
   */
  linked_at?: number;
  /**
   * Last synced timestamp (epoch ms)
   * @format int64
   */
  last_synced_time?: number;
  /** Accounts under this connection */
  accounts?: FinancialAccount[];
}

/** Get financial connection link token request */
export interface GetFinancialConnectRequest {
  /**
   * Client platform: ios / android / web / h5
   * @example "android"
   */
  client_type?: string;
  /**
   * Optional redirect URI for authorization callback
   * @example "https://app.opensocial.xyz/callback"
   */
  redirect_uri?: string;
  /**
   * Optional broker ID for authorization (SnapTrade etc.)
   * @format int64
   * @example 100001
   */
  broker_id?: number;
  /**
   * Optional account ID; may resolve connection for update mode
   * @example "123456"
   */
  account_id?: string;
  /** Plaid update mode; existing connection internal ID */
  id?: string;
}

export interface FinancialConnectResponse {
  /**
   * sub code
   * @format int32
   */
  code?: number;
  /** information for the response */
  msg?: string;
  /** Connection authorization response. Includes legacy Position connect fields; link_token and link_mode are additional fields for Plaid Financial Planner.  */
  data?: FinancialConnectInfo;
  errors?: Error[];
}

/** Connection authorization response. Includes legacy Position connect fields; link_token and link_mode are additional fields for Plaid Financial Planner.  */
export interface FinancialConnectInfo {
  /**
   * Portal authorization URL for the platform
   * @example "https://portal.snaptrade.com/authorize?client_id=xxx&redirect_uri=xxx"
   */
  portal_url?: string;
  /** Platform user ID */
  platform_user_id?: string;
  authorization_status?: "PENDING" | "AUTHORIZED" | "EXPIRED" | "REVOKED";
  /**
   * Authorization session ID / Plaid link_token for callback verification
   * @example "session_abc123"
   */
  session_id?: string;
  /**
   * Callback redirect URI
   * @example "https://app.opensocial.xyz/callback"
   */
  redirect_uri?: string;
  /**
   * Authorization expiration timestamp (if already authorized)
   * @format int64
   */
  expires_at?: number;
  /**
   * Authorization timestamp (if already authorized)
   * @format int64
   */
  authorized_at?: number;
  /**
   * Remaining number of authorization attempts; -1=unavailable
   * @format int32
   */
  remain_count?: number;
  /** Plaid link_token (Financial Planner; maps to session_id for Plaid) */
  link_token?: string;
  /** Plaid Link mode (create or update) */
  link_mode?: "create" | "update";
}

export interface FinancialConnectionListResponse {
  /**
   * sub code
   * @format int32
   */
  code?: number;
  /** information for the response */
  msg?: string;
  data?: FinancialConnection[];
  errors?: Error[];
}

/** Financial account */
export interface FinancialAccount {
  /** Internal account ID */
  id?: string;
  platform?:
    | "EDGEN"
    | "SNAPTRADE"
    | "OKX"
    | "BINANCE"
    | "HYPERLIQUID"
    | "PLAID"
    | "MANUAL";
  /**
   * Platform user ID
   * @example "user456"
   */
  platform_user_id?: string;
  /** Owner user ID */
  owner_id?: string;
  /** FK to connection */
  connection_id?: string;
  account_type?:
    | "FULL"
    | "SPOT"
    | "CASH"
    | "SWAP"
    | "FUTURES"
    | "checking"
    | "savings"
    | "money market"
    | "cd"
    | "cash management"
    | "hsa"
    | "prepaid"
    | "paypal"
    | "ebt"
    | "business"
    | "credit card"
    | "mortgage"
    | "student"
    | "auto"
    | "home equity"
    | "consumer"
    | "commercial"
    | "construction"
    | "loan"
    | "overdraft"
    | "brokerage"
    | "401k"
    | "403B"
    | "457b"
    | "401a"
    | "ira"
    | "roth"
    | "roth 401k"
    | "529"
    | "pension"
    | "mutual fund"
    | "stock plan"
    | "trust"
    | "ugma"
    | "utma"
    | "crypto exchange"
    | "non-taxable brokerage account"
    | "line of credit"
    | "other";
  /** @format int32 */
  asset_count?: number;
  /** Plaid account_id */
  platform_account_id?: string;
  type?: "DEPOSITORY" | "INVESTMENT" | "CREDIT" | "LOAN" | "OTHER";
  /** status */
  status?: string;
  /** broker */
  broker?: string;
  /** @format int64 */
  last_synced_time?: number;
  /**
   * Creation timestamp
   * @format int64
   * @example 1640995200000
   */
  created?: number;
  /**
   * Modification timestamp
   * @format int64
   * @example 1640995200000
   */
  modified?: number;
  /** Display name */
  account_name?: string;
  /** Account mask */
  account_mask?: string;
  /** Institution ID */
  institution_id?: string;
  /** Credit or overdraft limit ceiling—not amount used or available credit (decimal string). Plaid source: balances.limit. May be null when not applicable. Typical by type: CREDIT=commonly set; LOAN=occasionally (e.g. HELOC); DEPOSITORY/INVESTMENT/OTHER/non-Plaid usually null.  */
  current_balance?: JsonNullableString;
  /** Credit or overdraft limit ceiling—not amount used or available credit (decimal string). Plaid source: balances.limit. May be null when not applicable. Typical by type: CREDIT=commonly set; LOAN=occasionally (e.g. HELOC); DEPOSITORY/INVESTMENT/OTHER/non-Plaid usually null.  */
  available_balance?: JsonNullableString;
  /** Credit or overdraft limit ceiling—not amount used or available credit (decimal string). Plaid source: balances.limit. May be null when not applicable. Typical by type: CREDIT=commonly set; LOAN=occasionally (e.g. HELOC); DEPOSITORY/INVESTMENT/OTHER/non-Plaid usually null.  */
  credit_limit?: JsonNullableString;
  /**
   * Currency code
   * @example "USD"
   */
  currency_code?: string;
  /** Balance source */
  balance_source?:
    "INITIAL_SYNC" | "WEBHOOK" | "MANUAL_REFRESH" | "MANUAL_ENTRY";
  /**
   * Balance synced timestamp (epoch ms)
   * @format int64
   */
  balance_synced_time?: number;
  /** Whether included in net worth calculation */
  include_in_net_worth?: boolean;
}

/** Credit or overdraft limit ceiling—not amount used or available credit (decimal string). Plaid source: balances.limit. May be null when not applicable. Typical by type: CREDIT=commonly set; LOAN=occasionally (e.g. HELOC); DEPOSITORY/INVESTMENT/OTHER/non-Plaid usually null.  */
export interface JsonNullableString {
  present?: boolean;
}

export type FinancialNetWorthResponse = BaseResponse & {
  /** Financial dashboard net worth */
  data?: FinancialNetWorth;
};

/** Financial dashboard net worth */
export type FinancialNetWorth = FinancialModuleMetadata & {
  /** Current net worth as decimal string */
  amount?: string;
  /** Net worth amount at the beginning of the selected range as decimal string */
  previous_amount?: string;
  /** Net worth sparkline points */
  sparkline?: PricePoint[];
};

/** Financial account pagination data */
export interface FinancialAccountPagination {
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   */
  limit?: number;
  /**
   * Total count
   * @format int64
   */
  total?: number;
  /** Token for the next page; empty when no more results */
  next_token?: string;
  /** Account list */
  rows?: FinancialAccount[];
}

export type FinancialAccountPaginationResponse = BaseResponse & {
  /** Financial account pagination data */
  data?: FinancialAccountPagination;
};

/** Financial records list payload (rows shape depends on the requested type) */
export interface FinancialRecordsList {
  type?: string;
  limit?: number;
  total?: number;
  next_token?: string;
  rows?: Record<string, any>[];
}

export type FinancialRecordsListResponse = BaseResponse & {
  /** Financial records list payload (rows shape depends on the requested type) */
  data?: FinancialRecordsList;
};

/** List financial accounts request */
export interface ListFinancialAccountsRequest {
  /** Filter by internal account ID */
  id?: string;
  /** Filter by account owner ID */
  owner_id?: string;
  /** Filter by data source platform */
  platform?:
    | "EDGEN"
    | "SNAPTRADE"
    | "OKX"
    | "BINANCE"
    | "HYPERLIQUID"
    | "PLAID"
    | "MANUAL";
  /** Filter by third-party platform user ID */
  platform_user_id?: string;
  /** Filter by third-party platform account ID */
  platform_account_id?: string;
  /** Filter by financial account category (depository / investment / credit / loan / other) */
  type?: "DEPOSITORY" | "INVESTMENT" | "CREDIT" | "LOAN" | "OTHER";
  /** Filter by account subtype; SnapTrade SPOT/SWAP/FUTURES; Plaid/MANUAL checking/savings etc. */
  account_type?:
    | "FULL"
    | "SPOT"
    | "CASH"
    | "SWAP"
    | "FUTURES"
    | "checking"
    | "savings"
    | "money market"
    | "cd"
    | "cash management"
    | "hsa"
    | "prepaid"
    | "paypal"
    | "ebt"
    | "business"
    | "credit card"
    | "mortgage"
    | "student"
    | "auto"
    | "home equity"
    | "consumer"
    | "commercial"
    | "construction"
    | "loan"
    | "overdraft"
    | "brokerage"
    | "401k"
    | "403B"
    | "457b"
    | "401a"
    | "ira"
    | "roth"
    | "roth 401k"
    | "529"
    | "pension"
    | "mutual fund"
    | "stock plan"
    | "trust"
    | "ugma"
    | "utma"
    | "crypto exchange"
    | "non-taxable brokerage account"
    | "line of credit"
    | "other";
  /**
   * Filter by account lifecycle status. `0`=ACTIVE.
   * Server accepts integer; response `FinancialAccount.status` is string (e.g. `"0"`, `"2"`, `"3"`).
   * @format int32
   */
  status?: number;
  /**
   * Page size (1-100)
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  /** Pagination cursor returned by the previous page */
  next_token?: string;
}

/** Financial dashboard module metadata */
export interface FinancialModuleMetadata {
  /** Financial dashboard module status */
  status?: FinancialModuleStatusEnum;
  /** Optional user-facing message */
  message?: string;
  /** Optional data limitation disclaimer */
  disclaimer?: string;
  /**
   * Latest source data sync timestamp in epoch milliseconds
   * @format int64
   */
  last_synced_time?: number;
  /** Whether the module is calculated with all strict PRD fields available */
  strict_mapping_supported?: boolean;
}

export type FinancialAccountsResponse = BaseResponse & {
  /** Financial dashboard account breakdown */
  data?: FinancialAccounts;
};

/** Financial dashboard account breakdown */
export type FinancialAccounts = FinancialModuleMetadata & {
  /**
   * Total account count
   * @format int32
   */
  account_count?: number;
  /** Account breakdown list */
  breakdowns?: FinancialAccountBreakdown[];
};

/** Financial dashboard account breakdown */
export interface FinancialAccountBreakdown {
  /** Account breakdown display name */
  name?: string;
  /** Account breakdown amount as decimal string */
  amount?: string;
}

export type FinancialSpendingResponse = BaseResponse & {
  /** Financial dashboard monthly spending */
  data?: FinancialSpending;
};

/** Financial dashboard monthly spending */
export type FinancialSpending = FinancialModuleMetadata & {
  /** Current month spending amount as decimal string */
  amount?: string;
  /** Previous 3-month same-period average amount as decimal string */
  average_amount?: string;
  /** Amount above 3-month average as decimal string */
  diff_amount?: string;
  /** Spend pace annotation status. NORMAL hides annotation; ABOVE shows copy without category; ABOVE_WITH_DRIVER includes dominant category. */
  pace_status?: "NORMAL" | "ABOVE" | "ABOVE_WITH_DRIVER";
  /** Dominant overspend category display name (e.g. Shopping) */
  dominant_category?: string;
  /** Dominant category overage amount as decimal string */
  dominant_category_overage?: string;
  /** Optional backend-provided annotation text */
  annotation?: string;
  /** Current month cumulative spending sparkline */
  sparkline?: PricePoint[];
  /** Previous 3-month average cumulative spending sparkline */
  average_sparkline?: PricePoint[];
};

export type FinancialSpendingCategoriesResponse = BaseResponse & {
  /** Financial dashboard spending categories */
  data?: FinancialSpendingCategories;
};

/** Financial dashboard spending categories */
export type FinancialSpendingCategories = FinancialModuleMetadata & {
  /** Spending category list */
  categories?: FinancialSpendingCategory[];
};

/** Financial dashboard spending category */
export interface FinancialSpendingCategory {
  /** Category icon key or URL */
  icon?: string;
  /** Category display name */
  name?: string;
  /** Category spending amount as decimal string */
  amount?: string;
}

export type FinancialTransactionsResponse = BaseResponse & {
  /** Financial dashboard recent transactions */
  data?: FinancialTransactions;
};

/** Financial dashboard recent transactions */
export type FinancialTransactions = FinancialModuleMetadata & {
  /** Recent transaction rows */
  rows?: FinancialTransaction[];
  /**
   * Page size
   * @format int32
   */
  limit?: number;
  /** Token for the next page */
  next_token?: string;
};

/** Financial dashboard recent transaction */
export interface FinancialTransaction {
  /** Merchant or category image URL */
  image?: string;
  /** Merchant name */
  merchant?: string;
  /** Transaction description */
  description?: string;
  /**
   * Transaction display time in epoch milliseconds
   * @format int64
   */
  transaction_time?: number;
  /** Transaction amount as decimal string */
  amount?: string;
}

export type FinancialPortfolioResponse = BaseResponse & {
  /** Financial dashboard portfolio distribution */
  data?: FinancialPortfolio;
};

/** Financial dashboard portfolio distribution */
export type FinancialPortfolio = FinancialModuleMetadata & {
  /**
   * Total investment account count
   * @format int32
   */
  account_count?: number;
  /** Portfolio asset allocation list */
  allocations?: FinancialPortfolioBreakdown[];
};

/** Financial dashboard portfolio asset allocation */
export interface FinancialPortfolioBreakdown {
  /** Asset class display name */
  name?: string;
  /** Asset class amount as decimal string */
  amount?: string;
}

export type FinancialSubscriptionsResponse = BaseResponse & {
  /** Financial dashboard subscriptions */
  data?: FinancialSubscriptions;
};

/** Financial dashboard subscriptions */
export type FinancialSubscriptions = FinancialModuleMetadata & {
  /** Subscription rows */
  rows?: FinancialSubscription[];
  /**
   * Page size
   * @format int32
   */
  limit?: number;
  /** Token for the next page */
  next_token?: string;
};

/** Financial dashboard subscription */
export interface FinancialSubscription {
  /** Merchant name */
  merchant?: string;
  /** Stream description */
  description?: string;
  /** Recurring frequency */
  frequency?: string;
  /** Subscription amount as decimal string */
  amount?: string;
  /**
   * Next payment time in epoch milliseconds
   * @format int64
   */
  next_payment_time?: number;
}

export type FinancialPaymentsResponse = BaseResponse & {
  /** Financial dashboard upcoming payments */
  data?: FinancialPayments;
};

/** Financial dashboard upcoming payments */
export type FinancialPayments = FinancialModuleMetadata & {
  /** Upcoming payment rows */
  rows?: FinancialPayment[];
  /**
   * Page size
   * @format int32
   */
  limit?: number;
  /** Token for the next page */
  next_token?: string;
};

/** Financial dashboard upcoming payment */
export interface FinancialPayment {
  /** Merchant, lender, or category image URL */
  image?: string;
  /** Merchant, lender, or institution name */
  merchant?: string;
  /** Payment description */
  description?: string;
  /**
   * Due or predicted payment date in epoch milliseconds
   * @format int64
   */
  payment_time?: number;
  /** Payment amount as decimal string */
  amount?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string =
    "https://{region}-{environment}.opensocial.{domain}/v2/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Open Social API
 * @version 2.0.0
 * @baseUrl https://{region}-{environment}.opensocial.{domain}/v2/
 *
 * The Member API for Open Social Project
 */
export class MemberClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  member = {
    /**
     * @description query member products
     *
     * @tags MemberProduct
     * @name ListMemberProducts
     * @summary /member/products
     * @request GET:/member/products
     * @secure
     */
    listMemberProducts: (
      query?: {
        /** Language preference for the response */
        language?: string;
        /** Payment channels to filter (e.g. APPLE_IAP, GOOGLE_IAP) */
        pay_channels?: string[];
        /** Client platform (WEB / IOS / ANDROID). When set, each product only returns the payment configs offered on this platform, in configured order; when omitted (legacy clients) payment configs are not filtered by platform */
        platform?: "WEB" | "IOS" | "ANDROID";
      },
      params: RequestParams = {},
    ) =>
      this.request<MemberProductResponse, any>({
        path: `/member/products`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query my member @type GetMemberRequest
     *
     * @tags Member
     * @name GetMember
     * @summary /member/members/me
     * @request GET:/member/members/me
     * @secure
     */
    getMember: (
      query?: {
        /** Language preference for the response */
        language?: string;
        /**
         * if you need to return the credit balance information, set this to true (default). Set to false to skip credit query. Only available for active members with credit-enabled products.
         * @default true
         */
        "enrich.with_credit"?: boolean;
        /**
         * if you need to return available_products , set this to true (default).
         * @default true
         */
        "enrich.with_available_products"?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MemberResponse, any>({
        path: `/member/members/me`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query equities
     *
     * @tags Equity
     * @name ListEquities
     * @summary /equities
     * @request GET:/member/equities
     * @secure
     */
    listEquities: (
      query?: {
        /** Language preference for the response */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquityResponse, any>({
        path: `/member/equities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description redeemReward
     *
     * @tags Member
     * @name RedeemReward
     * @summary /members/redeem/{code}
     * @request POST:/member/members/redeem/{code}
     * @secure
     */
    redeemReward: (code: string, params: RequestParams = {}) =>
      this.request<RedeemCodeResponse, any>({
        path: `/member/members/redeem/${code}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description generateRedeemCode
     *
     * @tags Member
     * @name GenerateRedeemCode
     * @summary /members/redeem/generate
     * @request POST:/member/members/redeem/generate
     * @secure
     */
    generateRedeemCode: (
      query?: {
        /** limit */
        limit?: number;
        /** next_token */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RedeemCodePaginationResponse, any>({
        path: `/member/members/redeem/generate`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query grantable quantity for an equity code
     *
     * @tags Equity
     * @name QueryEquityGrant
     * @summary /equities/grant/{code}
     * @request GET:/member/equities/grant/{code}
     * @secure
     */
    queryEquityGrant: (code: EquityGrantCodeEnum, params: RequestParams = {}) =>
      this.request<EquityGrantQuantityResponse, any>({
        path: `/member/equities/grant/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description grant equity by code
     *
     * @tags Equity
     * @name GrantEquity
     * @summary /equities/grant/{code}
     * @request POST:/member/equities/grant/{code}
     * @secure
     */
    grantEquity: (code: EquityGrantCodeEnum, params: RequestParams = {}) =>
      this.request<EquityGrantResultResponse, any>({
        path: `/member/equities/grant/${code}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  recommend = {
    /**
     * @description get recommend users by type
     *
     * @tags Recommend
     * @name GetRecommendUsers
     * @summary /recommend/users/{type}
     * @request GET:/recommend/users/{type}
     * @secure
     */
    getRecommendUsers: (type: string, params: RequestParams = {}) =>
      this.request<RecommendThirdUserPaginationResponse, void>({
        path: `/recommend/users/${type}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reactions = {
    /**
     * @description add reaction
     *
     * @tags Reaction
     * @name AddReaction
     * @summary /reactions
     * @request POST:/reactions
     * @secure
     */
    addReaction: (data: AddReactionRequest, params: RequestParams = {}) =>
      this.request<ReactionResponse, any>({
        path: `/reactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  agents = {
    /**
     * @description get owner preference
     *
     * @tags Agents
     * @name GetPreference
     * @summary /agents/preferences
     * @request GET:/agents/preferences
     * @secure
     */
    getPreference: (params: RequestParams = {}) =>
      this.request<OwnerPreferenceResponse, void>({
        path: `/agents/preferences`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description add preference
     *
     * @tags Agents
     * @name AddPreference
     * @summary /agents/preferences
     * @request POST:/agents/preferences
     * @secure
     */
    addPreference: (data: AddPreferenceRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, void>({
        path: `/agents/preferences`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description get agent reports by category, agent, language, time range and pagination @type ListAgentReportRequest
     *
     * @tags Agents
     * @name ListAgentReport
     * @summary /agents/reports
     * @request GET:/agents/reports
     * @secure
     */
    listAgentReport: (
      query?: {
        /** agent report category */
        category?: AgentReportCategoryEnum;
        /** agent id list */
        agent_ids?: string[];
        /** include id list */
        ids?: string[];
        levels?: AgentReportLevelEnum[];
        /**
         * content language
         * @default "en-US"
         */
        language?: string;
        /** market */
        market?: string;
        /** @default false */
        count_today?: boolean;
        /**
         * If true, only return reports from the last 24 hours
         * @default false
         */
        last_24h?: boolean;
        /**
         * If true, only return asset-related reports
         * @default false
         */
        asset_only?: boolean;
        /**
         * If you need to return the token relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /** @default false */
        "enrich.with_content"?: boolean;
        /**
         * If you need to return the post relative information, set this to true.
         * @default false
         */
        "enrich.with_asset.enable"?: boolean;
        /** @default false */
        "enrich.with_asset.with_price"?: boolean;
        /**
         * page limit
         * @format int32
         * @min 1
         * @max 30
         * @default 20
         */
        limit?: number;
        /** next token for pagination */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentReportPaginationResponse, void>({
        path: `/agents/reports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get agents list
     *
     * @tags Agents
     * @name ListAgent
     * @summary /agents
     * @request GET:/agents
     * @secure
     */
    listAgent: (
      query?: {
        /**
         * language
         * @default "en-US"
         */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentResponse, void>({
        path: `/agents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get subscribed agents list
     *
     * @tags Agents
     * @name ListSubscribedAgent
     * @summary /agents/subscriptions
     * @request GET:/agents/subscriptions
     * @secure
     */
    listSubscribedAgent: (
      query?: {
        /**
         * page limit
         * @format int32
         * @min 1
         * @max 20
         * @default 10
         */
        limit?: number;
        /** next token for pagination */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentSubscriptionPaginationResponse, void>({
        path: `/agents/subscriptions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description subscribe agents
     *
     * @tags Agents
     * @name SubscribeAgents
     * @summary /agents/subscriptions
     * @request POST:/agents/subscriptions
     * @secure
     */
    subscribeAgents: (
      data: SubscribeAgentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, void>({
        path: `/agents/subscriptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description get daily report
     *
     * @tags Agents
     * @name DailyReport
     * @summary /agents/reports/daily
     * @request GET:/agents/reports/daily
     * @secure
     */
    dailyReport: (
      query?: {
        /**
         * agent id
         * @default 0
         */
        agent_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DailyReportDetailResponse, void>({
        path: `/agents/reports/daily`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get agent reports by asset_id
     *
     * @tags Agents
     * @name GetAgentReports
     * @summary /agents/reports/{asset_id}
     * @request GET:/agents/reports/{asset_id}
     * @secure
     */
    getAgentReports: (
      assetId: string,
      query?: {
        /** agent id */
        agent_id?: string;
        /**
         * content language
         * @default "en-US"
         */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SimpleAgentReportResponse, void>({
        path: `/agents/reports/${assetId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  positions = {
    /**
     * @description Query user account information
     *
     * @tags Position
     * @name GetUserAccounts
     * @summary Get User Accounts
     * @request GET:/positions/accounts
     * @secure
     */
    getUserAccounts: (
      query?: {
        /** Asset account platform type enumeration */
        platform?: PositionAccountPlatformEnum;
        /**
         * Owner ID. Required when the caller uses OS-Api-Key or server-to-server access without a user JWT;
         * if omitted in that case the API returns a login/parameter error (runtime validation in PositionOwnerResolver).
         */
        owner_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PositionAccountPaginationResponse, BaseResponse>({
        path: `/positions/accounts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add asset to user's positions
     *
     * @tags Position
     * @name AddUserPosition
     * @summary Add User Position
     * @request POST:/positions/accounts/{accountId}/assets
     * @secure
     */
    addUserPosition: (
      accountId: string,
      data: AddPositionAsset[],
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/positions/accounts/${accountId}/assets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get user's position information with category filtering
     *
     * @tags Position
     * @name GetUserPositions
     * @summary Get User Positions
     * @request GET:/positions/accounts/{accountId}/assets
     * @secure
     */
    getUserPositions: (
      accountId: string,
      query?: {
        /** Data source category filter */
        sort?: "REPORT_360";
        /** Asset IDs */
        asset_ids?: string[];
        /** Asset type enumeration */
        asset_type?: PositionAssetTypeEnum;
        /** Keyword for fuzzy match */
        keyword?: string;
        /**
         * The amount of positions requested from the APIs
         * @format int32
         * @max 20
         * @default 5
         */
        limit?: number;
        /** Pagination token */
        next_token?: string;
        /**
         * If you need to return enrich data
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * If you need to return the price symbol
         * @default false
         */
        "enrich.with_asset"?: boolean;
        /**
         * Whether the position has amount info
         * @default false
         */
        has_amount?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PositionAssetPaginationResponse, any>({
        path: `/positions/accounts/${accountId}/assets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove specified asset from user's positions
     *
     * @tags Position
     * @name RemoveUserPosition
     * @summary Remove User Position
     * @request DELETE:/positions/accounts/{accountId}/assets
     * @secure
     */
    removeUserPosition: (
      accountId: string,
      data: RemovePositionAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/positions/accounts/${accountId}/assets`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get user's position performance with category filtering
     *
     * @tags Position
     * @name GetUserPerformancePositions
     * @summary Get User Positions performance
     * @request GET:/positions/accounts/{accountId}/assets/performance
     * @secure
     */
    getUserPerformancePositions: (
      accountId: string,
      query?: {
        /** PNL or VALUE */
        type?: "PNL" | "VALUE";
        /**
         * Data aggregation time period. Supported values [1d,7d,30d,90d,180d]
         * @default "1d"
         */
        period?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PositionPerformanceResponse, any>({
        path: `/positions/accounts/${accountId}/assets/performance`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new order for a position
     *
     * @tags Position
     * @name CreatePositionOrder
     * @summary Create Position Order
     * @request POST:/positions/accounts/{accountId}/orders
     * @secure
     */
    createPositionOrder: (
      accountId: string,
      data: CreatePositionOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/positions/accounts/${accountId}/orders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get orders for a position
     *
     * @tags Position
     * @name GetPositionOrders
     * @summary Get Position Orders
     * @request GET:/positions/accounts/{accountId}/orders
     * @secure
     */
    getPositionOrders: (
      accountId: string,
      query?: {
        /** Asset ID */
        asset_id?: string;
        /** Asset type enumeration */
        asset_type?: PositionAssetTypeEnum;
        /**
         * Maximum number of items to return
         * @format int32
         * @default 20
         */
        limit?: number;
        /** Token for pagination */
        nextToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PositionOrderPaginationResponse, any>({
        path: `/positions/accounts/${accountId}/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a specific position order
     *
     * @tags Position
     * @name UpdatePositionOrder
     * @summary Update Position Order
     * @request PUT:/positions/accounts/{accountId}/orders/{orderId}
     * @secure
     */
    updatePositionOrder: (
      accountId: string,
      orderId: string,
      data: CreatePositionOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/positions/accounts/${accountId}/orders/${orderId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a specific position order
     *
     * @tags Position
     * @name DeletePositionOrder
     * @summary Delete Position Order
     * @request DELETE:/positions/accounts/{accountId}/orders/{orderId}
     * @secure
     */
    deletePositionOrder: (
      accountId: string,
      orderId: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/positions/accounts/${accountId}/orders/${orderId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the list of configured brokers for external asset import
     *
     * @tags Position
     * @name GetPositionBrokers
     * @summary Get Broker List
     * @request GET:/positions/brokers
     * @secure
     */
    getPositionBrokers: (
      query?: {
        /** Channel filter (plaid / snaptrade). When omitted, returns all brokers regardless of channel. */
        channel?: "plaid" | "snaptrade";
        /** Institution type filter (INVEST / BANKING) for Plaid popular-institution tiles. institutionTypes is multi-valued; a cross-type institution (e.g. Charles Schwab) matches both. */
        institutionType?: "INVEST" | "BANKING";
      },
      params: RequestParams = {},
    ) =>
      this.request<PositionBrokersResponse, any>({
        path: `/positions/brokers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the portal authorization URL for a specific trading platform. Returns the authorization link and current authorization status.
     *
     * @tags Position
     * @name GetPlatformConnect
     * @summary Get Platform Authorization URL
     * @request GET:/positions/breaker/{platform}/connect
     * @secure
     */
    getPlatformConnect: (
      platform: PositionAccountPlatformEnum,
      query?: {
        /**
         * Optional redirect URI for authorization callback. If not provided, a default will be used.
         * @example "https://app.opensocial.xyz/callback"
         */
        redirect_uri?: string;
        /**
         * Optional broker ID for authorization
         * @format int64
         * @example 100001
         */
        brokerId?: number;
        /**
         * Optional Account Id
         * @example 123456
         */
        accountId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PlatformConnectResponse, BaseResponse>({
        path: `/positions/breaker/${platform}/connect`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Process the authorization callback from a trading platform after user authorization. This endpoint: 1. Validates the authorization code and session 2. Exchanges the authorization code for access tokens (platform-specific) 3. Retrieves user account information from the platform 4. Creates or updates the position account in the system 5. Returns the account information Supported platforms: - Snaptrade: Requires code and state parameters - OKX: Requires code parameter - Binance: Requires code parameter
     *
     * @tags Position
     * @name HandlePlatformAuthorization
     * @summary Handle Platform Authorization Callback
     * @request POST:/positions/breaker/{platform}/authorization
     * @secure
     */
    handlePlatformAuthorization: (
      platform: PositionAccountPlatformEnum,
      data: PlatformAuthorizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlatformAuthorizationResponse, BaseResponse>({
        path: `/positions/breaker/${platform}/authorization`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Synchronize position data (assets and orders) from a third-party trading platform. This endpoint: 1. Fetches the latest holdings/positions from the platform 2. Fetches the latest orders from the platform 3. Saves the data to the database 4. Returns the synchronization result The synchronization can be performed for: - Assets only (set sync_assets=true, sync_orders=false) - Orders only (set sync_assets=false, sync_orders=true) - Both (set sync_assets=true, sync_orders=true) Note: This operation may take some time depending on the amount of data. Consider implementing this as an asynchronous operation for large datasets.
     *
     * @tags Position
     * @name SyncPositionData
     * @summary Sync Position Data from Platform
     * @request POST:/positions/accounts/{accountId}/sync
     * @secure
     */
    syncPositionData: (
      accountId: string,
      data?: SyncPositionDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<SyncPositionDataResponse, BaseResponse>({
        path: `/positions/accounts/${accountId}/sync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a position account and all associated data. This operation will: 1. Remove the account from the system 2. Delete all associated assets and orders 3. Revoke platform authorization if applicable Note: This operation is irreversible. Please ensure you want to delete the account before proceeding.
     *
     * @tags Position
     * @name DeletePositionAccount
     * @summary Delete Position Account
     * @request DELETE:/positions/accounts/{accountId}
     * @secure
     */
    deletePositionAccount: (accountId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, BaseResponse>({
        path: `/positions/accounts/${accountId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get aggregated position summary by owner, with optional asset grouping
     *
     * @tags Position
     * @name GetOwnerPositionSummary
     * @summary Get owner position summary
     * @request GET:/positions/owners/summary
     * @secure
     */
    getOwnerPositionSummary: (
      query?: {
        /** Account IDs to filter */
        account_ids?: string[];
        /** Financial account type (Plaid Account.type) */
        financial_type?:
          "depository" | "investment" | "credit" | "loan" | "other";
        /**
         * Whether to group by asset
         * @default false
         */
        with_asset_group?: boolean;
        /**
         * Page size
         * @max 100
         * @default 20
         */
        limit?: number;
        /** Pagination cursor */
        next_token?: string;
        /**
         * Whether to include asset name/symbol
         * @default false
         */
        with_asset?: boolean;
        /**
         * Whether to include owner position performance
         * @default false
         */
        with_position_performance?: boolean;
        /** Performance type */
        performance_type?: "PNL" | "VALUE";
        /** Data aggregation time period. Supported values [1d,7d,30d,90d,180d] */
        performance_period?: string;
        /** Filter by connection ID */
        connection_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnerPositionSummaryResponse, any>({
        path: `/positions/owners/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  opportunities = {
    /**
     * @description Get opportunity summary with total return and S&P500 comparison (AI_PICK only). Optionally include 180-day performance chart data. @type GetOpportunitySummaryRequest
     *
     * @tags Opportunities
     * @name GetOpportunitySummary
     * @summary Get opportunity summary
     * @request GET:/opportunities/summary
     * @secure
     */
    getOpportunitySummary: (
      query?: {
        /** Winning rate types to include */
        types?: OpportunityTypeEnum[];
        /**
         * Market filter (e.g., US, HK)
         * @default "US"
         */
        market?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OpportunitySummaryResponse, void>({
        path: `/opportunities/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List opportunities with pagination, filtering by type and status. Supports data enrichment options. @type ListOpportunitiesRequest
     *
     * @tags Opportunities
     * @name ListOpportunities
     * @summary List opportunities
     * @request GET:/opportunities
     * @secure
     */
    listOpportunities: (
      query?: {
        /** Business type */
        type?: OpportunityTypeEnum;
        /** Status filter */
        status?: OpportunityStatusEnum;
        /**
         * Whether to enable data enrichment
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * Whether to return asset detailed information (logo, current_price)
         * @default false
         */
        "enrich.with_asset.enable"?: boolean;
        /** Whether to return price */
        "enrich.with_asset.with_price"?: boolean;
        /** Whether to return ipo */
        "enrich.with_asset.with_ipo"?: boolean;
        /** Whether to return theme info */
        "enrich.with_asset.with_theme"?: boolean;
        /**
         * Whether to return impact information
         * @default false
         */
        "enrich.with_impact"?: boolean;
        /**
         * Language code (e.g., en-US, zh-CN)
         * @default "en-US"
         */
        language?: string;
        /**
         * Page limit
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        limit?: number;
        /** Next token for pagination */
        next_token?: string;
        /** stock status */
        asset_status?: "APPLYING" | "PENDING" | "LISTED";
        /**
         * Start time
         * @format int64
         */
        start_time?: number;
        /**
         * End time
         * @format int64
         */
        end_time?: number;
        /**
         * Market filter (e.g., US, HK)
         * @default "US"
         */
        market?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OpportunityPaginationResponse, void>({
        path: `/opportunities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get opportunity detail by ID. Includes report content (consumes Credit). @type GetOpportunityRequest
     *
     * @tags Opportunities
     * @name GetOpportunity
     * @summary Get opportunity detail
     * @request GET:/opportunities/{id}
     * @secure
     */
    getOpportunity: (
      id: string,
      query?: {
        /**
         * Whether to enable data enrichment
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * Whether to return impact information
         * @default false
         */
        "enrich.with_impact"?: boolean;
        /**
         * Language code (e.g., en-US, zh-CN)
         * @default "en-US"
         */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OpportunityResponse, void>({
        path: `/opportunities/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get opportunity detail by IDs. Includes report content (consumes Credit). @type GetOpportunityRequest
     *
     * @tags Opportunities
     * @name GetOpportunity2
     * @summary Get opportunity detail
     * @request GET:/opportunities/batch
     * @originalName getOpportunity
     * @duplicate
     * @secure
     */
    getOpportunity2: (
      query?: {
        /** List of Opportunity IDs */
        ids?: string[];
        /**
         * Whether to enable data enrichment
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * Whether to return asset detailed information (logo, current_price)
         * @default false
         */
        "enrich.with_asset.enable"?: boolean;
        /** Whether to return price */
        "enrich.with_asset.with_price"?: boolean;
        /** Whether to return ipo */
        "enrich.with_asset.with_ipo"?: boolean;
        /** Whether to return theme info */
        "enrich.with_asset.with_theme"?: boolean;
        /**
         * Whether to return impact information
         * @default false
         */
        "enrich.with_impact"?: boolean;
        /**
         * Language code (e.g., en-US, zh-CN)
         * @default "en-US"
         */
        language?: string;
        /**
         * Whether to require unlock for the opportunity
         * @default false
         */
        require_unlock?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<OpportunityResponse, void>({
        path: `/opportunities/batch`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  payment = {
    /**
     * @description Check offer eligibility; when eligible returns offer_details, owner_external_ref, productId; when not returns offer_details[].eligible=false
     *
     * @tags Payment
     * @name PaymentCheck
     * @summary /payment/check
     * @request POST:/payment/check
     * @secure
     */
    paymentCheck: (data: PaymentCheckRequest, params: RequestParams = {}) =>
      this.request<PaymentCheckResponse, any>({
        path: `/payment/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description After subscription success, verify and create/update subscription; same logic as Webhook SUBSCRIBED; must be idempotent
     *
     * @tags Payment
     * @name PaymentConfirm
     * @summary /payment/confirm
     * @request POST:/payment/confirm
     * @secure
     */
    paymentConfirm: (data: PaymentConfirmRequest, params: RequestParams = {}) =>
      this.request<PaymentConfirmResponse, any>({
        path: `/payment/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description create payment
     *
     * @tags Payment
     * @name Create
     * @summary /payment/plans
     * @request POST:/payment/plans
     * @secure
     */
    create: (data: CreatePaymentPlanRequest, params: RequestParams = {}) =>
      this.request<PaymentPlanResponse, any>({
        path: `/payment/plans`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description list payment plans @type ListPaymentPlanRequest
     *
     * @tags Payment
     * @name ListPayment
     * @summary /payment/plans
     * @request GET:/payment/plans
     * @secure
     */
    listPayment: (
      query?: {
        /** Next token */
        next_token?: string;
        /** Limit */
        limit?: number;
        /** Status */
        status?: PaymentPlanStatus[];
        /** Business type */
        business_type?: PayBusinessType;
        /** payment plan ID */
        id?: string;
        /** token usage */
        pay_type?: PayType;
        /** Payment channel */
        pay_channel?: PayChannel;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentPlanPaginationResponse, void>({
        path: `/payment/plans`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description list payment record @type ListPaymentRecordRequest
     *
     * @tags Payment
     * @name ListPaymentRecord
     * @summary /payment/records
     * @request GET:/payment/records
     * @secure
     */
    listPaymentRecord: (
      query?: {
        /** Owner ID */
        owner_id?: string;
        /** Next token */
        next_token?: string;
        /** Limit */
        limit?: number;
        /** Status */
        status?: string[];
        /** Business type */
        business_type?: PayBusinessType;
        /** Pay channel */
        pay_channel?: PayChannel;
        business_types?: PayBusinessType[];
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentRecordPaginationResponse, void>({
        path: `/payment/records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description cancel payment plan
     *
     * @tags Payment
     * @name Cancel
     * @summary /payment/plan/{id}/cancel
     * @request POST:/payment/plan/{id}/cancel
     * @secure
     */
    cancel: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/payment/plan/${id}/cancel`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description turn auto-renew off at period end or resume it
     *
     * @tags Payment
     * @name UpdatePaymentPlan
     * @summary /payment/plan/{id}
     * @request PATCH:/payment/plan/{id}
     * @secure
     */
    updatePaymentPlan: (
      id: string,
      data: PlanUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentPlanResponse, any>({
        path: `/payment/plan/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description create a session to update the subscription payment method
     *
     * @tags Payment
     * @name CreatePaymentMethodSession
     * @summary /payment/plan/{id}/payment-method-sessions
     * @request POST:/payment/plan/{id}/payment-method-sessions
     * @secure
     */
    createPaymentMethodSession: (
      id: string,
      data: PaymentMethodSessionCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentMethodSessionResponse, any>({
        path: `/payment/plan/${id}/payment-method-sessions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description query (and idempotently apply) a payment method session
     *
     * @tags Payment
     * @name GetPaymentMethodSession
     * @summary /payment/plan/{id}/payment-method-sessions/{session_id}
     * @request GET:/payment/plan/{id}/payment-method-sessions/{session_id}
     * @secure
     */
    getPaymentMethodSession: (
      id: string,
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<PaymentMethodSessionResponse, any>({
        path: `/payment/plan/${id}/payment-method-sessions/${sessionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description change the subscription to another product in place
     *
     * @tags Payment
     * @name ChangePaymentPlan
     * @summary /payment/plan/{id}/changes
     * @request POST:/payment/plan/{id}/changes
     * @secure
     */
    changePaymentPlan: (
      id: string,
      data: PlanChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlanChangeResultResponse, any>({
        path: `/payment/plan/${id}/changes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  ciks = {
    /**
     * @description Get featured CIK investors list with their position summary
     *
     * @tags CIK
     * @name GetFeaturedCikList
     * @summary /ciks
     * @request GET:/ciks
     * @secure
     */
    getFeaturedCikList: (
      query?: {
        /**
         * Whether to return portfolio 30d change percentage data
         * @default false
         */
        with_change?: boolean;
        /**
         * Whether to return top NEW_POSITION and CLOSED_POSITION data
         * @default false
         */
        with_top_change_positions?: boolean;
        /**
         * Whether to return top value asset data
         * @default false
         */
        with_top_value_positions?: boolean;
        /**
         * Maximum number of records to return
         * @default 10
         */
        limit?: number;
        /**
         * Offset for pagination (number of records to skip)
         * @default 0
         */
        offset?: number;
        /** Language code , defaults to English. */
        language?: string;
        /** CIK numbers list to query specific CIKs */
        ids?: string[];
        /** CIK with asset option */
        enrich_option?: PositionAssetEnrichOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<CikResponse, void>({
        path: `/ciks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get CIK position details
     *
     * @tags CIK
     * @name GetCikPositions
     * @summary /ciks/{cik}/positions
     * @request GET:/ciks/{cik}/positions
     * @secure
     */
    getCikPositions: (
      cik: string,
      query?: {
        /**
         * Sort method - change (sort by changeType and amount) or weight (sort by position weight)
         * @default "WEIGHT"
         */
        sort?: "CHANGE" | "WEIGHT";
        /** Pagination token returned from previous request, pass to get next page */
        next_token?: string;
        /**
         * Maximum number of position records to return per page
         * @default 20
         */
        limit?: number;
        /** CIK with asset option */
        enrich_option?: PositionAssetEnrichOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<CikPositionDetailResponse, void>({
        path: `/ciks/${cik}/positions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * @description send auth code by type
     *
     * @tags Authentication
     * @name SendCode
     * @summary /auth/code
     * @request POST:/auth/code
     */
    sendCode: (data: SendCodeRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/auth/code`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description validate parameters before login. anonymous accessible. currently supports invite_code
     *
     * @tags Authentication
     * @name Validate
     * @summary /auth/validate
     * @request GET:/auth/validate
     */
    validate: (
      query?: {
        /**
         * invite code, spread code or redeem code entered by the user
         * @example "NJE6rv"
         */
        invite_code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InviteValidationResponse, void>({
        path: `/auth/validate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description get challenge by address
     *
     * @tags auth
     * @name GetChallenge
     * @summary /auth/challenge
     * @request GET:/auth/challenge
     * @secure
     */
    getChallenge: (
      query: {
        /**
         * wallet address
         * @example "0xD8805CEcaD06E93Fc0976Ac8d094beeEA269ae37"
         */
        address: string;
        /**
         * auth type
         * @example ""
         */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChallengeResponse, void>({
        path: `/auth/challenge`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description login by challenge
     *
     * @tags auth
     * @name Authenticate
     * @summary /auth/login
     * @request POST:/auth/login
     * @secure
     */
    authenticate: (data: AuthRequest, params: RequestParams = {}) =>
      this.request<TokenResponse, void>({
        path: `/auth/login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description get id_token by accessToken
     *
     * @tags auth
     * @name IdToken
     * @summary /auth/id_token
     * @request GET:/auth/id_token
     * @secure
     */
    idToken: (params: RequestParams = {}) =>
      this.request<IdTokenResponse, void>({
        path: `/auth/id_token`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description refresh access token
     *
     * @tags auth
     * @name RefreshToken
     * @summary /auth/refresh
     * @request POST:/auth/refresh
     * @secure
     */
    refreshToken: (
      query: {
        /**
         * refresh access token
         * @example ""
         */
        refresh_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TokenResponse, void>({
        path: `/auth/refresh`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  members = {
    /**
     * @description query member retention stats
     *
     * @tags Mixture
     * @name GetMemberRetentionStats
     * @summary /members/retention-stats
     * @request GET:/members/retention-stats
     * @secure
     */
    getMemberRetentionStats: (params: RequestParams = {}) =>
      this.request<MemberRetentionStatsResponse, any>({
        path: `/members/retention-stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  owners = {
    /**
     * No description
     *
     * @tags owners
     * @name UpdateOwnerSetting
     * @summary /owners/{owner_id}/setting
     * @request POST:/owners/{owner_id}/setting
     * @secure
     */
    updateOwnerSetting: (
      ownerId: string,
      data: {
        /**
         * local setting
         * @example "en-us"
         */
        locale?: string;
        /**
         * Ed 称呼用户的昵称；写 ksocial
         * @maxLength 64
         */
        nick_name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnerResponse, any>({
        path: `/owners/${ownerId}/setting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  relations = {
    /**
     * No description
     *
     * @tags relations
     * @name ListOwnerInvitees
     * @summary /v2/relations/owners/{owner_id}/invitees
     * @request GET:/relations/owners/{owner_id}/invitees
     * @secure
     */
    listOwnerInvitees: (
      ownerId: string,
      query?: {
        /** query request body */
        filter?: ListRelationRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnerPaginationResponse, any>({
        path: `/relations/owners/${ownerId}/invitees`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  wallet = {
    /**
     * @description wallet sign for payment or claim
     *
     * @tags wallet
     * @name Sign
     * @summary /wallet/sign
     * @request POST:/wallet/sign
     * @secure
     */
    sign: (data: WalletSignRequest, params: RequestParams = {}) =>
      this.request<WalletSignResponse, any>({
        path: `/wallet/sign`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tx = {
    /**
     * @description sync transaction status
     *
     * @tags tx
     * @name Sync
     * @summary /tx/sync
     * @request POST:/tx/sync
     * @secure
     */
    sync: (data: SyncRequest, params: RequestParams = {}) =>
      this.request<TransactionResponse, any>({
        path: `/tx/sync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  rebates = {
    /**
     * @description list rebates
     *
     * @tags rebates
     * @name ListRebates
     * @summary /rebates
     * @request GET:/rebates
     * @secure
     */
    listRebates: (
      query?: {
        /**
         * @format int32
         * @min 1
         * @max 20
         */
        limit?: number;
        next_token?: string;
        level?: string;
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RebatePaginationResponse, any>({
        path: `/rebates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get rebate summary
     *
     * @tags rebates
     * @name GetRebateSummary
     * @summary /rebates/summary
     * @request GET:/rebates/summary
     * @secure
     */
    getRebateSummary: (
      query?: {
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RebateSummaryResponse, any>({
        path: `/rebates/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  financial = {
    /**
     * @description Process authorization callback from a trading platform or Plaid Link. Compatible with legacy Position authorization body; public_token/institution_* are Plaid additions. Exchange public_token (Plaid) or legacy credentials, upsert connection/accounts, trigger INITIAL_SYNC.
     *
     * @tags FinancialConnections
     * @name ProcessFinancialAuthorization
     * @summary Process financial connection authorization
     * @request POST:/financial/connections/{platform}/authorization
     * @secure
     */
    processFinancialAuthorization: (
      platform:
        | "EDGEN"
        | "SNAPTRADE"
        | "OKX"
        | "BINANCE"
        | "HYPERLIQUID"
        | "PLAID"
        | "MANUAL",
      data: FinancialAuthorizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<FinancialConnectionListResponse, BaseResponse>({
        path: `/financial/connections/${platform}/authorization`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get platform authorization URL or Plaid Link token for SDK initialization. Compatible with legacy Position connect; id is an additional field for Plaid update mode.
     *
     * @tags FinancialConnections
     * @name GetFinancialConnect
     * @summary Get financial connection link token
     * @request GET:/financial/connections/{platform}/connect
     * @secure
     */
    getFinancialConnect: (
      platform:
        | "EDGEN"
        | "SNAPTRADE"
        | "OKX"
        | "BINANCE"
        | "HYPERLIQUID"
        | "PLAID"
        | "MANUAL",
      query?: {
        /**
         * Client platform: ios / android / web / h5
         * @example "android"
         */
        client_type?: string;
        /**
         * Optional redirect URI for authorization callback
         * @example "https://app.opensocial.xyz/callback"
         */
        redirect_uri?: string;
        /**
         * Optional broker ID for authorization (SnapTrade etc.)
         * @format int64
         * @example 100001
         */
        broker_id?: number;
        /**
         * Optional account ID; may resolve connection for update mode
         * @example "123456"
         */
        account_id?: string;
        /** Plaid update mode; existing connection internal ID */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialConnectResponse, BaseResponse>({
        path: `/financial/connections/${platform}/connect`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Disconnect a third-party connection and revoke platform authorization.
     *
     * @tags FinancialConnections
     * @name RemoveFinancialConnection
     * @summary Remove financial connection
     * @request DELETE:/financial/connections/{platform}/{connectionId}
     * @secure
     */
    removeFinancialConnection: (
      platform:
        | "EDGEN"
        | "SNAPTRADE"
        | "OKX"
        | "BINANCE"
        | "HYPERLIQUID"
        | "PLAID"
        | "MANUAL",
      connectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/financial/connections/${platform}/${connectionId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List third-party connections for a platform, including nested accounts.
     *
     * @tags FinancialConnections
     * @name ListFinancialConnections
     * @summary List financial connections
     * @request GET:/financial/connections/{platform}
     * @secure
     */
    listFinancialConnections: (
      platform:
        | "EDGEN"
        | "SNAPTRADE"
        | "OKX"
        | "BINANCE"
        | "HYPERLIQUID"
        | "PLAID"
        | "MANUAL",
      params: RequestParams = {},
    ) =>
      this.request<FinancialConnectionListResponse, any>({
        path: `/financial/connections/${platform}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginated list of financial accounts with multi-field filters. owner_id is resolved from the authorization Token when present; otherwise falls back to the query parameter.
     *
     * @tags FinancialAccounts
     * @name ListFinancialAccounts
     * @summary List financial accounts (paginated)
     * @request GET:/financial/accounts/page
     * @secure
     */
    listFinancialAccounts: (
      query?: {
        /** Filter by internal account ID */
        id?: string;
        /** Filter by account owner ID */
        owner_id?: string;
        /** Filter by data source platform */
        platform?:
          | "EDGEN"
          | "SNAPTRADE"
          | "OKX"
          | "BINANCE"
          | "HYPERLIQUID"
          | "PLAID"
          | "MANUAL";
        /** Filter by third-party platform user ID */
        platform_user_id?: string;
        /** Filter by third-party platform account ID */
        platform_account_id?: string;
        /** Filter by financial account category (depository / investment / credit / loan / other) */
        type?: "DEPOSITORY" | "INVESTMENT" | "CREDIT" | "LOAN" | "OTHER";
        /** Filter by account subtype; SnapTrade SPOT/SWAP/FUTURES; Plaid/MANUAL checking/savings etc. */
        account_type?:
          | "FULL"
          | "SPOT"
          | "CASH"
          | "SWAP"
          | "FUTURES"
          | "checking"
          | "savings"
          | "money market"
          | "cd"
          | "cash management"
          | "hsa"
          | "prepaid"
          | "paypal"
          | "ebt"
          | "business"
          | "credit card"
          | "mortgage"
          | "student"
          | "auto"
          | "home equity"
          | "consumer"
          | "commercial"
          | "construction"
          | "loan"
          | "overdraft"
          | "brokerage"
          | "401k"
          | "403B"
          | "457b"
          | "401a"
          | "ira"
          | "roth"
          | "roth 401k"
          | "529"
          | "pension"
          | "mutual fund"
          | "stock plan"
          | "trust"
          | "ugma"
          | "utma"
          | "crypto exchange"
          | "non-taxable brokerage account"
          | "line of credit"
          | "other";
        /**
         * Filter by account lifecycle status. `0`=ACTIVE (Plaid/MANUAL active accounts).
         * Aligns with `FinancialAccount.status` string `"0"` when filtering invest coverage.
         * @format int32
         */
        status?: number;
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        limit?: number;
        /** Pagination cursor returned by the previous page */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialAccountPaginationResponse, any>({
        path: `/financial/accounts/page`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List financial records by `type`. `payload` is a JSON string (camelCase) with type-specific filters (`accountIds`, `limit`, `nextToken`, `status` / `dataStatus`). Response envelope uses snake_case (`next_token`). Each element of `rows` depends on `type`; callers that only need to know whether the user has holdings (EDG-561) read `rows.length` of `type=POSITION_ASSET` with `limit=1`. Contract source: perplexica `src/agent/api/financial/openapi.yaml` (`/financial/records`).
     *
     * @tags FinancialRecords
     * @name ListFinancialRecords
     * @summary List financial records
     * @request GET:/financial/records
     * @secure
     */
    listFinancialRecords: (
      query: {
        /** Financial record type discriminator */
        type:
          | "ACCOUNT_BALANCE"
          | "OTHER_ASSET"
          | "BANK_TRANSACTION"
          | "LIABILITY"
          | "RECURRING_STREAM"
          | "POSITION_ASSET"
          | "POSITION_ORDER";
        /**
         * JSON string (camelCase) with type-specific query filters, e.g. {"limit":1}
         * @example "{"accountIds":["acc_1"],"limit":50,"nextToken":""}"
         */
        payload?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialRecordsListResponse, any>({
        path: `/financial/records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get current net worth, change, and Plaid-only trend points for the logged-in owner.
     *
     * @tags Financial
     * @name GetFinancialNetWorth
     * @summary Get financial net worth
     * @request GET:/financial/net-worth
     * @secure
     */
    getFinancialNetWorth: (
      query?: {
        /**
         * Whether to exclude MANUAL data from the current value
         * @default false
         */
        exclude_manual?: boolean;
        /**
         * Trend range
         * @default "YTD"
         */
        range?: "1W" | "1M" | "3M" | "6M" | "YTD" | "1Y" | "ALL";
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialNetWorthResponse, any>({
        path: `/financial/net-worth`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get account breakdown card data for the logged-in owner.
     *
     * @tags Financial
     * @name GetFinancialAccounts
     * @summary Get financial account breakdown
     * @request GET:/financial/account/breakdown
     * @secure
     */
    getFinancialAccounts: (
      query?: {
        /**
         * Whether to exclude MANUAL accounts
         * @default false
         */
        exclude_manual?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialAccountsResponse, any>({
        path: `/financial/account/breakdown`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get current month spending and previous 3-month same-period average for the logged-in owner.
     *
     * @tags Financial
     * @name GetFinancialSpending
     * @summary Get financial monthly spending
     * @request GET:/financial/spending/summary
     * @secure
     */
    getFinancialSpending: (
      query?: {
        /**
         * Whether to exclude MANUAL data
         * @default false
         */
        exclude_manual?: boolean;
        /**
         * Target month in YYYY-MM format. Defaults to current month.
         * @pattern ^[0-9]{4}-[0-9]{2}$
         * @example "2026-07"
         */
        month?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialSpendingResponse, any>({
        path: `/financial/spending/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get spending categories based on Plaid Personal Finance Category.
     *
     * @tags Financial
     * @name GetFinancialSpendingCategories
     * @summary Get financial spending categories
     * @request GET:/financial/spending/categories
     * @secure
     */
    getFinancialSpendingCategories: (
      query?: {
        /**
         * Whether to exclude MANUAL data
         * @default false
         */
        exclude_manual?: boolean;
        /**
         * Spending category range
         * @default "CURRENT_MONTH"
         */
        range?: "CURRENT_MONTH" | "LAST_MONTH" | "LAST_3_MONTHS";
        /**
         * Max categories before grouping remaining categories into Other
         * @format int32
         * @min 1
         * @max 50
         * @default 16
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialSpendingCategoriesResponse, any>({
        path: `/financial/spending/categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get recent depository and credit transactions with pending state.
     *
     * @tags Financial
     * @name GetFinancialTransactions
     * @summary Get financial recent transactions
     * @request GET:/financial/transaction
     * @secure
     */
    getFinancialTransactions: (
      query?: {
        /**
         * Whether to exclude MANUAL data
         * @default false
         */
        exclude_manual?: boolean;
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number;
        /** Pagination cursor */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialTransactionsResponse, any>({
        path: `/financial/transaction`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get investment account holdings grouped by Stocks, ETFs, Bonds, Crypto, Cash, and Other.
     *
     * @tags Financial
     * @name GetFinancialPortfolioDistribution
     * @summary Get financial portfolio distribution
     * @request GET:/financial/portfolio/distribution
     * @secure
     */
    getFinancialPortfolioDistribution: (
      query?: {
        /**
         * Whether to exclude MANUAL investment data
         * @default false
         */
        exclude_manual?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialPortfolioResponse, any>({
        path: `/financial/portfolio/distribution`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get active subscription-like recurring outflow streams.
     *
     * @tags Financial
     * @name GetFinancialSubscriptions
     * @summary Get financial subscriptions
     * @request GET:/financial/subscriptions
     * @secure
     */
    getFinancialSubscriptions: (
      query?: {
        /**
         * Whether to exclude MANUAL data
         * @default false
         */
        exclude_manual?: boolean;
        /**
         * Frequency filter
         * @default "ALL"
         */
        frequency?: "ALL" | "MONTHLY" | "ANNUAL";
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number;
        /** Pagination cursor */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialSubscriptionsResponse, any>({
        path: `/financial/subscriptions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get upcoming payments merged from recurring streams and liabilities.
     *
     * @tags Financial
     * @name GetFinancialPayments
     * @summary Get financial payments
     * @request GET:/financial/payments
     * @secure
     */
    getFinancialPayments: (
      query: {
        /**
         * Whether to exclude MANUAL data
         * @default false
         */
        exclude_manual?: boolean;
        /** Payment status. Only UPCOMING is supported in the first version. */
        status: "UPCOMING";
        /**
         * Future days window
         * @format int32
         * @min 1
         * @max 14
         * @default 7
         */
        days?: number;
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number;
        /** Pagination cursor */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FinancialPaymentsResponse, any>({
        path: `/financial/payments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
